import React__default, { createElement, forwardRef, useState, useEffect } from 'react';
import { jsx, Box, Button as Button$1, Heading as Heading$1, Card as Card$1, Grid, Flex, useThemeUI, Spinner } from 'theme-ui';
import { v4 } from 'uuid';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Menu as Menu$1, MenuButton, MenuList, MenuLink, MenuItem } from '@reach/menu-button';
import Modal$1 from 'react-modal';
import { Persist as Persist$1 } from 'formik-persist';
import { Formik, Form as Form$1, useFormikContext, useField } from 'formik';
import { Manager, Reference, Popper } from 'react-popper';
import matchSorter from 'match-sorter';
import Downshift, { useMultipleSelection, useSelect, useCombobox } from 'downshift';
import isequal from 'lodash.isequal';
import debounce from 'lodash.debounce';
import SignaturePad from 'signature_pad';
import { Global } from '@emotion/core';
import FocusLock from 'react-focus-lock';
import { Tabs as Tabs$1, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var iconMapping = function iconMapping(type) {
  switch (type) {
    case 'warning':
      return 'warning';

    case 'danger':
      return 'danger';

    case 'success':
      return 'check-circle';

    case 'circle':
      return 'circle';

    case 'check':
      return 'check';

    case 'check-circle':
      return 'check-circle';

    case 'upload':
      return 'upload';

    case 'copy':
      return 'copy';

    case 'calendar':
      return 'calendar';

    case 'setting':
      return 'setting';

    case 'download':
      return 'download';

    case 'edit':
      return 'edit';

    case 'eye-open':
      return 'eye';

    case 'eye-closed':
      return 'eye-slash';

    case 'file':
      return 'file';

    case 'file-error':
      return 'file-error';

    case 'filter':
      return 'filter';

    case 'envelope':
      return 'envelope';

    case 'envelope-error':
      return 'envelope-error';

    case 'envelope-success':
      return 'envelope-success';

    case 'list':
      return 'list-ul';

    case 'grid':
      return 'card';

    case 'send':
      return 'message';

    case 'meatballs':
      return 'meatballs';

    case 'kebab':
      return 'kebab';

    case 'attachment':
      return 'paperclip';

    case 'plus':
      return 'plus';

    case 'sync':
      return 'refresh';

    case 'search':
      return 'search';

    case 'payment':
      return 'payment';

    case 'file-info':
      return 'file-info';

    case 'trash':
      return 'trash';

    case 'user':
      return 'user';

    case 'user-circle':
      return 'user-circle';

    case 'users':
      return 'users';

    case 'times':
      return 'times';

    case 'times-circle':
      return 'times-circle';

    case 'calculator':
      return 'calculator';

    case 'info':
      return 'info-circle';

    case 'phone':
      return 'phone';

    case 'refresh':
      return 'refresh';

    case 'angle-left':
      return 'angle-left';

    case 'angle-right':
      return 'angle-right';

    case 'angle-up':
      return 'angle-up';

    case 'angle-down':
      return 'angle-down';

    case 'arrow-left':
      return 'arrow-left';

    case 'arrow-right':
      return 'arrow-right';

    case 'arrow-double-left':
      return 'angle-double-left';

    case 'arrow-double-right':
      return 'angle-double-right';

    case 'arrow-up':
      return 'arrow-up';

    case 'arrow-down':
      return 'arrow-down';

    case 'sort':
      return 'sort';

    case 'avatar':
      return 'user-circle';

    case 'question':
      return 'question';

    case 'clipboard':
      return 'clipboard-notes';

    case 'paperclip':
      return 'paperclip';

    case 'keyboard':
      return 'keyboard';

    case 'home':
      return 'home';

    case 'money-sign':
      return 'dollar';

    case 'minus-circle':
      return 'minus-circle';

    case 'minus':
      return 'minus';

    case 'color-warning':
      return 'warning-color';

    case 'color-success':
      return 'check-circle-color';

    case 'color-plus':
      return 'plus-circle-filled';

    case 'color-times':
      return 'times-circle-filled';

    case 'color-danger':
      return 'danger-color';

    case 'color-info':
      return 'info-circle-color';

    case 'color-minus':
      return 'minus-circle-filled';

    case 'color-back':
      return 'circle-chevron-left-color';

    case 'color-triangle':
      return 'caret-down';

    case 'color-question':
      return 'question-circle-filled';

    case 'color-next':
      return 'circle-chevron-right-color';

    case 'arrow-circle-filled-up':
      return 'arrow-circle-up-filled';

    case 'arrow-circle-filled-left':
      return 'arrow-circle-left-filled';

    case 'arrow-circle-filled-down':
      return 'arrow-circle-down-filled';

    case 'arrow-circle-filled-right':
      return 'arrow-circle-right-filled';

    case 'notes':
      return 'comment';

    case 'notes-filled':
      return 'comment-filled';

    case 'notes-plus':
      return 'comment-plus';

    case 'file-edit':
      return 'file-edit';

    case 'logout':
      return 'logout';

    case 'lock':
      return 'lock';

    case 'lock-open':
      return 'lock-open';

    case 'file-dollar':
      return 'file-dollar';

    case 'credit':
      return 'credit';

    case 'clock':
      return 'clock';

    case 'file-plus':
      return 'file-plus';

    case 'question-circle-filled':
      return 'question-circle-filled';

    case 'question-circle':
      return 'question-circle';

    case 'in-progress':
      return 'in-progress';

    case 'waiting':
      return 'waiting';

    case 'block':
      return 'block';

    case 'minus-circle-filled':
      return 'minus-circle-filled';

    case 'arrow-circle-down':
      return 'arrow-circle-down';

    case 'arrow-circle-left':
      return 'arrow-circle-left';

    case 'arrow-circle-right':
      return 'arrow-circle-right';

    case 'arrow-circle-up':
      return 'arrow-circle-up';

    case 'info-filled':
      return 'info-circle-filled';

    case 'times-circle-filled':
      return 'times-circle-filled';

    case 'user-circle-filled':
      return 'user-circle-filled';

    case 'user-filled':
      return 'user-filled';

    case 'users-filled':
      return 'users-filled';

    case 'danger-filled':
      return 'danger-filled';

    case 'warning-filled':
      return 'warning-filled';

    case 'success-filled':
      return 'check-circle-filled';

    case 'check-color':
      return 'check-color';

    case 'upload-alt':
      return 'upload-alt';

    case 'file-alt':
      return 'file-alt';

    case 'setting-filled':
      return 'setting-filled';

    case 'bell':
      return 'bell';

    case 'bell-filled':
      return 'bell-filled';

    case 'caret-left':
      return 'caret-left';

    case 'caret-right':
      return 'caret-right';

    case 'caret-up':
      return 'caret-up';

    case 'caret-down':
      return 'caret-down';

    case 'sort-selected':
      return 'sort-down';

    case 'menu':
      return 'menu';

    case 'envelope-edit':
      return 'envelope-edit';

    case 'undo':
      return 'undo';

    case 'plus-circle-filled':
      return 'plus-circle-filled';

    case 'plus-circle':
      return 'plus-circle';

    case 'chart':
      return 'chart-outline';

    case 'chart-filled':
      return 'chart-filled';

    case 'chart-pie':
      return 'chart-pie';

    case 'chart-growth':
      return 'chart-growth';

    case 'chart-bar':
      return 'chart-bar';

    default:
      throw new Error("icon type: " + type + " does not exist");
  }
};

var sizeVariants = {
  xs: '14px',
  sm: '18px',
  md: '24px',
  lg: '32px',
  xl: '64px'
};
var Icon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'warning' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'inline-block' : _ref$display,
      title = _ref.title,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "size", "display", "title", "sx"]);

  var iconType = iconMapping(variant);
  var dimension = Array.isArray(size) ? size.map(function (x) {
    return sizeVariants[x];
  }) : sizeVariants[size];
  return jsx(Box, Object.assign({
    as: "svg",
    // @ts-ignore
    viewBox: "0 0 24 24",
    "data-component": "Icon",
    ref: ref,
    sx: _extends({
      display: display,
      width: dimension,
      height: dimension
    }, sx)
  }, props), title && jsx("title", null, title), jsx("use", {
    href: "#icon-" + iconType,
    xlinkHref: "#icon-" + iconType
  }));
});

var hiddenVisually = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
  // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
  whiteSpace: 'nowrap',
  wordWrap: 'normal'
};

var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React__default.createElement(Box, Object.assign({}, rest, {
    as: "span",
    "data-component": "VisuallyHidden",
    sx: hiddenVisually
  }), children);
};

var AlertBanner = function AlertBanner(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      _ref$textOnly = _ref.textOnly,
      textOnly = _ref$textOnly === void 0 ? true : _ref$textOnly;
  var alertId = React__default.useMemo(function () {
    return v4();
  }, []);
  var iconMapping = {
    danger: 'color-danger',
    warning: 'color-warning',
    info: 'color-info'
  };
  var iconType = iconMapping[variant];
  var message = {
    danger: 'Critical: ',
    warning: 'Warning: ',
    info: 'Info: '
  };
  var isCritical = Boolean(variant === 'danger' || variant === 'warning');
  return React__default.createElement(Box, {
    "aria-describedby": alertId,
    tabIndex: 0,
    variant: "alert.banner-" + variant,
    role: isCritical ? 'alert' : 'status',
    "aria-live": isCritical ? 'assertive' : 'polite',
    sx: {
      gridTemplateColumns: showIcon ? '25px 1fr' : '1fr'
    }
  }, showIcon && React__default.createElement(Icon, {
    "aria-hidden": true,
    variant: iconType
  }), React__default.createElement(Box, {
    id: alertId,
    sx: textOnly ? {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    } : {}
  }, React__default.createElement(VisuallyHidden, null, message[variant]), children));
};

var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      rest = _objectWithoutPropertiesLoose(_ref, ["variant", "type"]);

  return createElement(Button$1, Object.assign({
    type: type,
    "data-component": "Button"
  }, rest, {
    variant: variant
  }));
};

var ButtonLink = function ButtonLink(props) {
  return React__default.createElement(Button, Object.assign({
    sx: {
      color: 'primary.base',
      fontSize: 2,
      textDecoration: 'underline',
      fontWeight: 400,
      textTransform: 'none',
      '&:hover': {
        color: 'primary.d2',
        bg: 'transparent',
        textDecoration: 'underline'
      },
      px: 0
    },
    variant: "ghost"
  }, props));
};

var ButtonBack = function ButtonBack(_ref) {
  var _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["sx", "children"]);

  var styles = _extends({
    color: 'primary.base',
    textTransform: 'none',
    fontSize: 2,
    py: '1px',
    px: 0,
    ':hover': {
      bg: 'transparent',
      textDecoration: 'underline'
    }
  }, sx);

  return React__default.createElement(Button, Object.assign({
    sx: styles,
    variant: "ghost"
  }, rest), React__default.createElement(Box, {
    sx: {
      bg: 'primary.base',
      px: '1px',
      mr: 2,
      borderRadius: 'full'
    }
  }, React__default.createElement(Icon, {
    variant: "arrow-left",
    color: "white",
    sx: {
      '::before': {
        mx: 0,
        ml: '-1px'
      }
    }
  })), children);
};

var AlertInline = function AlertInline(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "onDismiss", "children", "autoFocus", "sx"]);

  var ref = React__default.useRef(null);
  var alertId = React__default.useMemo(function () {
    return v4();
  }, []);
  React__default.useEffect(function () {
    if (ref.current && autoFocus) ref.current.focus();
  }, [ref.current]);
  var isCritical = Boolean(variant === 'danger' || variant === 'warning');
  var iconVariant = "color-" + variant;
  return React__default.createElement(Box, Object.assign({
    "aria-describedby": alertId,
    tabIndex: 0,
    ref: ref,
    className: onDismiss ? 'on-dismiss' : '',
    role: isCritical ? 'alert' : 'status',
    "aria-live": isCritical ? 'assertive' : 'polite'
  }, props, {
    variant: "alert.inline",
    sx: _extends({
      bg: variant + ".l2",
      borderColor: variant + ".base"
    }, sx)
  }), React__default.createElement(Icon, {
    "aria-hidden": true,
    variant: iconVariant,
    color: variant + ".base"
  }), React__default.createElement("div", {
    id: alertId
  }, children), onDismiss && React__default.createElement(Button, {
    onClick: onDismiss,
    variant: "ghost",
    sx: {
      height: '40px',
      px: 0,
      width: '40px',
      color: variant + ".d1",
      ':hover': {
        bg: variant + ".l15"
      }
    },
    "aria-label": "Dismiss"
  }, React__default.createElement(Icon, {
    variant: "times",
    size: "md",
    "aria-hidden": true
  })));
};

var isLinkAction = function isLinkAction(action) {
  return action.to !== undefined;
};

var NotifyAlert = function NotifyAlert(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      type = _ref.type,
      message = _ref.message,
      onDismiss = _ref.onDismiss,
      action = _ref.action,
      rest = _objectWithoutPropertiesLoose(_ref, ["variant", "type", "message", "onDismiss", "action"]);

  var alertId = React__default.useMemo(function () {
    return v4();
  }, []);
  var isCritical = Boolean(variant === 'danger' || variant === 'warning');
  var prefixMessage = {
    info: 'Info: ',
    success: 'Success: ',
    warning: 'Warning: ',
    danger: 'Danger: '
  };

  var _ref2 = action || {},
      label = _ref2.label,
      actionProps = _objectWithoutPropertiesLoose(_ref2, ["label"]);

  var snackbar = {
    container: {
      maxWidth: '600px',
      width: '100%'
    },
    content: {
      display: 'grid',
      gridTemplateColumns: '1fr max-content',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  };
  var toast = {
    container: {
      maxWidth: ['auto', '450px'],
      width: '100%',
      mx: [0, 2],
      mb: 1
    },
    content: {
      display: 'flex',
      flexFlow: 'column wrap',
      alignItems: 'flex-start',
      '& .action': {
        mt: 2
      }
    }
  };
  var style = type === 'toast' ? toast : snackbar;
  return React__default.createElement(Box, Object.assign({
    variant: "alert.toast",
    className: onDismiss ? 'on-dismiss' : '',
    "aria-describedby": alertId,
    tabIndex: 0,
    role: isCritical ? 'alert' : 'status',
    "aria-live": isCritical ? 'assertive' : 'polite',
    sx: _extends({
      py: action && [3, 2],
      zIndex: 99999
    }, style.container)
  }, rest), React__default.createElement(Icon, {
    "aria-hidden": true,
    // @ts-ignore
    variant: "color-" + variant,
    color: variant + ".base"
  }), React__default.createElement(Box // @ts-ignore
  , {
    // @ts-ignore
    sx: style.content
  }, React__default.createElement("div", {
    id: alertId
  }, React__default.createElement(VisuallyHidden, null, prefixMessage[variant]), message), action && React__default.createElement(Box, {
    sx: {
      mt: [2, 0]
    }
  }, React__default.createElement(Button, Object.assign({
    className: "action",
    as: isLinkAction(action) ? Link : 'button'
  }, actionProps, {
    sx: {
      ml: '2px'
    }
  }), label))), onDismiss && React__default.createElement(Button, {
    onClick: onDismiss,
    className: "button-dismiss",
    variant: "ghost",
    sx: {
      height: 40,
      px: 0,
      width: 40,
      color: 'inherit'
    },
    "aria-label": "Dismiss"
  }, React__default.createElement(Icon, {
    variant: "times",
    size: "md",
    "aria-hidden": true
  })));
};

var notifyContext = /*#__PURE__*/React__default.createContext(undefined);
var useNotify = function useNotify() {
  var context = React__default.useContext(notifyContext);
  if (!context) throw new Error('no context provider for notify');
  return context;
};

var NotifyProvider = function NotifyProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React__default.useState(),
      activeSnack = _React$useState[0],
      setSnack = _React$useState[1];

  var _React$useState2 = React__default.useState([]),
      toasts = _React$useState2[0],
      updateToast = _React$useState2[1];

  var _React$useState3 = React__default.useState({}),
      snackbar = _React$useState3[0],
      _addSnack = _React$useState3[1];

  var snackAnimation = {
    initial: {
      opacity: 0,
      y: 50,
      scale: 0.3
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.5,
      transition: {
        duration: 0.2
      }
    }
  };

  var removeToast = function removeToast(id) {
    updateToast(function (list) {
      return list.filter(function (x) {
        return x.id !== id;
      });
    });
  };

  var value = {
    addSnack: function addSnack(snack) {
      var _Object$assign;

      var id = v4();

      _addSnack(Object.assign({}, snackbar, (_Object$assign = {}, _Object$assign[id] = snack, _Object$assign)));

      setSnack(id);
      setTimeout(function () {
        _addSnack(function (snacks) {
          var _Object$assign2;

          return Object.assign({}, snacks, (_Object$assign2 = {}, _Object$assign2[id] = undefined, _Object$assign2));
        });
      }, 6000);
    },
    clearSnack: function clearSnack() {
      setSnack(undefined);

      _addSnack({});
    },
    clearToasts: function clearToasts() {
      return updateToast([]);
    },
    addToast: function addToast(toast) {
      var id = v4();
      updateToast(toasts.concat([_extends(_extends({}, toast), {}, {
        id: id
      })]));
      setTimeout(function () {
        return removeToast(id);
      }, 6000);
      return id;
    },
    removeToast: removeToast
  };
  var activeSnackbar = activeSnack ? snackbar[activeSnack] : undefined;
  return jsx(notifyContext.Provider, {
    value: value
  }, children, jsx(AnimatePresence, null, activeSnackbar && jsx(motion.div, Object.assign({
    style: {
      position: 'fixed',
      bottom: '24px',
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      left: 0,
      zIndex: 999999
    }
  }, snackAnimation), jsx(NotifyAlert, Object.assign({}, activeSnackbar, {
    type: "snackbar"
  })))), jsx(AnimatePresence, null, jsx(Box, {
    as: "ul",
    sx: {
      position: 'fixed',
      top: 3,
      right: [0, 3],
      listStyleType: 'none',
      p: 0,
      zIndex: 999999,
      m: 0
    }
  }, toasts.map(function (_ref2) {
    var id = _ref2.id,
        toast = _objectWithoutPropertiesLoose(_ref2, ["id"]);

    return jsx(motion.li, Object.assign({
      key: id,
      // @ts-ignore
      positionTransition: true
    }, snackAnimation), jsx(NotifyAlert, Object.assign({
      type: "toast"
    }, toast, {
      onDismiss: function onDismiss() {
        return removeToast(id);
      }
    })));
  }))));
};

var Badge = function Badge(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "children"]);

  var prefix = {
    neutral: null,
    primary: null,
    success: 'Success: ',
    danger: 'Critical: ',
    warning: 'Warning: ',
    info: 'Info: '
  };
  return React__default.createElement(Box, Object.assign({
    variant: "badge." + variant
  }, props), prefix[variant] && React__default.createElement(VisuallyHidden, null, prefix[variant]), children);
};

var CardHeader = function CardHeader(_ref) {
  var children = _ref.children,
      cardVariant = _ref.cardVariant,
      actions = _ref.actions;
  return React__default.createElement(Box, {
    as: "header",
    sx: {
      m: -3,
      mb: 3,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      py: 2,
      px: 3,
      borderTopLeftRadius: 'rounded',
      borderTopRightRadius: 'rounded',
      bg: cardVariant === 'focus' ? 'primary.l3' : 'neutral.l4'
    }
  }, React__default.createElement(Box, null, children), actions && React__default.createElement(Box, {
    sx: {
      ml: 'auto'
    }
  }, actions.map(function (_ref2) {
    var title = _ref2.title,
        onClick = _ref2.onClick,
        id = _ref2.id;
    return React__default.createElement(Button, {
      key: id,
      my: -2,
      ml: [0, 1],
      variant: "ghost",
      onClick: onClick
    }, title);
  })));
};

var Heading = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
      as = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "as"]);

  return (// @ts-ignore
    React__default.createElement(Heading$1, Object.assign({
      as: as || variant,
      "data-component": "Heading",
      variant: variant,
      ref: ref
    }, props))
  );
});

var Card = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "children", "header", "footer"]);

  return (// @ts-ignore
    React__default.createElement(Card$1, Object.assign({
      variant: variant
    }, props, {
      ref: ref
    }), header && React__default.createElement(CardHeader, {
      actions: header.actions,
      cardVariant: variant
    }, React__default.createElement(Heading, {
      as: header.as,
      variant: "h6",
      sx: {
        display: 'flex',
        alignItems: 'center'
      }
    }, header.icon && React__default.createElement(Icon, {
      variant: header.icon,
      mr: 2,
      size: "sm"
    }), header.title)), children, footer && React__default.createElement(Box, {
      as: "footer",
      sx: {
        m: -3,
        mt: 3,
        py: 2,
        px: 3,
        bg: variant === 'focus' ? 'primary.l3' : 'neutral.l4'
      }
    }, footer))
  );
});

var CompletionContainer = function CompletionContainer(_ref) {
  var _ref$initialOpen = _ref.initialOpen,
      initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'incomplete' : _ref$status,
      title = _ref.title,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      description = _ref.description,
      content = _ref.content;
  var prefix = React__default.useMemo(function () {
    return v4();
  }, []);

  var _React$useState = React__default.useState(isFocused ? false : !initialOpen),
      isCollapsed = _React$useState[0],
      toggleCollapse = _React$useState[1];

  var iconVariant = {
    incomplete: {
      icon: 'circle',
      status: 'Incomplete: ',
      styles: {
        fontSize: 24,
        transform: 'translateX(-1px)',
        color: 'neutral.l2'
      }
    },
    warning: {
      icon: 'color-warning',
      status: 'Warning: ',
      styles: {
        transform: 'translateX(-.5px)',
        width: 24,
        height: 24
      }
    },
    danger: {
      icon: 'color-danger',
      status: 'Critical: ',
      styles: {
        transform: 'translateX(-1px)',
        width: 25,
        height: 25
      }
    },
    complete: {
      icon: 'color-success',
      status: 'Complete: ',
      styles: {
        transform: 'translateX(-1px)',
        width: 25,
        height: 25
      }
    },
    inProgress: {
      icon: 'in-progress',
      status: 'In Progress: ',
      styles: {
        transform: 'translateX(-1px)',
        width: 25,
        height: 25
      }
    }
  };
  var boxStyles = !isCollapsed ? {
    border: '1px solid',
    bg: isFocused ? 'primary.l4' : 'background.depth.0',
    py: 2,
    mb: 2,
    px: 2,
    borderRadius: 'rounded',
    borderColor: isFocused ? 'primary.l4' : 'neutral.l2'
  } : {};
  var section = prefix + "-section";
  var titleAria = prefix + "-title";
  return React__default.createElement(Box, {
    as: "li",
    sx: _extends({
      display: 'grid',
      gridTemplateColumns: '24px 32px 1fr',
      gap: 1,
      alignItems: 'flex-start',
      zIndex: 100,
      position: 'relative',
      px: '9px'
    }, boxStyles)
  }, React__default.createElement(Box, {
    className: "icon-container",
    sx: {
      height: '100%',
      bg: !isCollapsed ? 'transparent !important' : undefined
    }
  }, React__default.createElement(Box, {
    sx: {
      overflow: 'hidden',
      width: 24,
      height: 24,
      bg: isCollapsed ? 'background.depth.0' : 'transparent',
      py: '2px',
      boxSizing: 'content-box'
    }
  }, React__default.createElement(Icon // @ts-ignore
  , {
    // @ts-ignore
    variant: iconVariant[status].icon,
    sx: iconVariant[status].styles
  }))), React__default.createElement(Button, {
    variant: "ghost",
    onClick: function onClick() {
      return toggleCollapse(!isCollapsed);
    },
    sx: {
      px: 0,
      mt: '-2px',
      py: 0,
      height: 24,
      width: '100%',
      color: 'neutral.base'
    }
  }, React__default.createElement(Icon, {
    variant: isCollapsed ? 'angle-right' : 'angle-down'
  }), React__default.createElement(VisuallyHidden, null, isCollapsed ? 'Show' : 'Hide')), React__default.createElement(Box, {
    sx: {
      pb: 3
    }
  }, React__default.createElement(Box, {
    as: "button",
    "aria-expanded": isCollapsed,
    "aria-controls": section,
    onClick: function onClick() {
      return toggleCollapse(!isCollapsed);
    },
    sx: {
      border: 'none',
      bg: 'transparent',
      textAlign: 'left',
      p: 0,
      cursor: 'pointer'
    }
  }, React__default.createElement(Heading, {
    id: titleAria,
    variant: "h5",
    as: "h4"
  }, React__default.createElement(VisuallyHidden, null, iconVariant[status].status), title), description && React__default.createElement(Box, {
    variant: "text.small",
    sx: {
      color: 'neutral.l1'
    }
  }, description)), React__default.createElement(Box, {
    id: section,
    "aria-labelledby": titleAria,
    role: "region"
  }, !isCollapsed && React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, content))));
};

var CompletionList = function CompletionList(_ref) {
  var items = _ref.items;
  var content = items.map(function (x) {
    return React__default.createElement(CompletionContainer, Object.assign({}, x, {
      key: x.title.replace(/ /g, '-')
    }));
  });
  return React__default.createElement(Box, {
    as: "ul",
    sx: {
      listStyleType: 'none',
      pl: 0,
      position: 'relative',
      '& li:last-of-type .icon-container': {
        bg: 'white'
      }
    }
  }, content, React__default.createElement(Box, {
    role: "presentation",
    "aria-hidden": true,
    sx: {
      position: 'absolute',
      left: 19,
      top: 0,
      height: '100%',
      bg: 'neutral.l2',
      width: 2
    }
  }));
};

var DataList = /*#__PURE__*/React__default.forwardRef( // @ts-ignore
function (_ref, ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [1, 2, 3] : _ref$columns,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["columns", "items", "children"]);

  return React__default.createElement(Grid, Object.assign({
    as: "dl",
    ref: ref,
    columns: columns
  }, rest), items.map(function (_ref2) {
    var text = _ref2.text,
        label = _ref2.label,
        textStyles = _ref2.textStyles,
        titleStyles = _ref2.titleStyles;
    var key = label.replace(/ /g, '-');
    return React__default.createElement(Box, {
      key: key
    }, React__default.createElement(Box, {
      as: "dt",
      sx: _extends({
        variant: 'text.small',
        fontWeight: 500,
        color: 'neutral.base',
        display: 'flex',
        alignItems: 'center',
        mb: '2px'
      }, titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.sx)
    }, label, (titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.icon) && React__default.createElement(Icon, Object.assign({
      size: "sm",
      sx: {
        ml: (titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.icon.variant.includes('color')) ? 1 : 0
      }
    }, titleStyles === null || titleStyles === void 0 ? void 0 : titleStyles.icon))), React__default.createElement(Box, {
      as: "dd",
      sx: _extends({
        display: 'flex',
        alignItems: 'center'
      }, textStyles === null || textStyles === void 0 ? void 0 : textStyles.sx)
    }, text, text === undefined || text === null && React__default.createElement(VisuallyHidden, null, "No definition available"), (textStyles === null || textStyles === void 0 ? void 0 : textStyles.icon) && React__default.createElement(Icon, Object.assign({
      size: "sm",
      sx: {
        ml: (textStyles === null || textStyles === void 0 ? void 0 : textStyles.icon.variant.includes('color')) ? 1 : 0
      }
    }, textStyles === null || textStyles === void 0 ? void 0 : textStyles.icon))));
  }), children);
});

var isLinkItem = function isLinkItem(x) {
  return Boolean(x.onSelect === undefined);
};

var isSeperatorItem = function isSeperatorItem(x) {
  return x.type === 'seperator';
};

var Menu = function Menu(_ref) {
  var children = _ref.children,
      listItems = _ref.listItems,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  var styles = {
    py: 2,
    px: '6px',
    width: '100%',
    display: 'block',
    textDecoration: 'none',
    color: 'text.positive',
    cursor: 'pointer',
    '&[data-selected]': {
      bg: 'primary.l4'
    }
  };
  return React__default.createElement(Box, {
    as: Menu$1,
    sx: sx
  }, React__default.createElement(Box, {
    as: MenuButton,
    variant: "buttons." + variant
  }, children), React__default.createElement(Card, {
    variant: "float",
    // @ts-ignore
    as: MenuList,
    sx: {
      p: 0,
      borderRadius: 'rounded',
      minWidth: 192,
      '&:focus': {
        outline: 'none'
      }
    }
  }, listItems.map(function (item) {
    if (isSeperatorItem(item)) return React__default.createElement(Box, {
      sx: {
        borderTop: '1px solid',
        borderColor: 'neutral.l3',
        my: 2,
        mx: 1
      }
    });

    var content = item.content,
        rest = _objectWithoutPropertiesLoose(item, ["content"]);

    if (isLinkItem(item)) {
      return (// @ts-ignore
        React__default.createElement(Box, Object.assign({
          as: MenuLink
        }, rest, {
          sx: styles
        }), content)
      );
    }

    return (// @ts-ignore
      React__default.createElement(Box, Object.assign({
        as: MenuItem
      }, rest, {
        sx: styles
      }), content)
    );
  })));
};

var DrawerControls = function DrawerControls(_ref) {
  var actions = _ref.actions;

  if (actions.length > 3) {
    console.warn('Drawer component given actions array length greater than 3');
  }

  return React__default.createElement(Box, {
    sx: {
      px: 3,
      py: 3,
      position: ['static', 'fixed'],
      bottom: 0,
      alignItems: 'center',
      display: 'flex',
      flexFlow: ['column', 'row-reverse'],
      gap: [0, 2],
      ml: [0, -3],
      mr: [0, -3],
      mb: [-3, 0],
      mt: [3, 0],
      maxWidth: '100%',
      width: '100%',
      borderTop: '1px solid',
      borderColor: 'neutral.l3',
      '& > button': {
        minWidth: ['100%', 180]
      }
    }
  }, actions.map(function (_ref2, index) {
    var label = _ref2.label,
        props = _objectWithoutPropertiesLoose(_ref2, ["label"]);

    var key = ['primary', 'secondary', 'tertiary'];
    return React__default.createElement(React__default.Fragment, {
      key: key[index]
    }, React__default.createElement(Button, Object.assign({
      sx: {
        my: [1, 0],
        mr: index === 2 ? 'auto' : undefined
      },
      variant: index === 0 ? 'primary' : 'secondary'
    }, props), label));
  }));
};

Modal$1.defaultStyles = {
  overlay: {
    position: 'fixed',
    zIndex: 99999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {}
};

var Drawer = function Drawer(_ref) {
  var title = _ref.title,
      children = _ref.children,
      _ref$descriptionList = _ref.descriptionList,
      descriptionList = _ref$descriptionList === void 0 ? [] : _ref$descriptionList,
      isOpen = _ref.isOpen,
      _ref$dimension = _ref.dimension,
      dimension = _ref$dimension === void 0 ? 0 : _ref$dimension,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant,
      backAction = _ref.backAction,
      onDismiss = _ref.onDismiss,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["title", "children", "descriptionList", "isOpen", "dimension", "variant", "backAction", "onDismiss", "sx"]);

  var drawerPrefix = React__default.useMemo(function () {
    return v4();
  }, []);
  React__default.useEffect(function () {
    if (typeof window !== 'undefined') {
      Modal$1.setAppElement('#root');
    }
  }, []);
  React__default.useEffect(function () {
    if (!document) return function () {};

    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return function () {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);
  var titleId = drawerPrefix + "-title";
  var width = {
    base: [624, 1248, '100%'],
    small: [360, 720, '100%']
  };
  return React__default.createElement(Modal$1, {
    portalClassName: "modal-drawer",
    shouldCloseOnOverlayClick: true,
    onRequestClose: function onRequestClose() {
      return onDismiss();
    },
    isOpen: isOpen,
    aria: {
      labelledby: titleId
    }
  }, React__default.createElement(Box, Object.assign({}, rest, {
    sx: _extends({
      height: '100%',
      position: 'absolute',
      right: 0,
      bg: 'white',
      maxWidth: width[variant][dimension] || 624,
      width: '100%',
      boxShadow: 'drawer',
      overflow: ['auto', 'visible'],
      display: 'grid',
      gridTemplateRows: ['56px 1fr auto', '56px calc(100vh - 120px) 64px']
    }, sx)
  }), React__default.createElement(Box, {
    sx: {
      bg: 'primary.d3',
      height: 56,
      display: 'grid',
      alignItems: 'center',
      px: 3,
      gridTemplateColumns: '1fr 45px',
      color: 'text.negative'
    }
  }, React__default.createElement(Heading, {
    id: titleId,
    variant: "h3"
  }, title), React__default.createElement(Button, {
    onClick: onDismiss,
    variant: "ghost",
    sx: {
      p: 0,
      color: 'text.negative',
      '&:hover': {
        bg: 'primary.d1'
      }
    },
    "aria-label": "Dismiss"
  }, React__default.createElement(Icon, {
    "aria-hidden": "true",
    role: "presentation",
    variant: "times",
    size: "lg"
  }))), React__default.createElement(Box, {
    sx: {
      overflowY: ['visible', 'auto']
    }
  }, backAction && React__default.createElement(Box, {
    sx: {
      bg: 'neutral.l4',
      borderBottom: '1px solid',
      py: 1,
      borderColor: 'neutral.l3'
    }
  }, React__default.createElement(Button, {
    onClick: backAction.onClick,
    variant: "ghost",
    sx: {
      textTransform: 'none',
      fontSize: 2,
      color: 'primary.base'
    }
  }, React__default.createElement(Icon, {
    variant: "color-back",
    "aria-hidden": "true",
    sx: {
      mr: 2
    },
    size: "md"
  }), backAction.label)), Boolean(descriptionList.length) && React__default.createElement(DataList, {
    sx: {
      bg: 'neutral.l4',
      p: 3
    },
    items: descriptionList
  }), React__default.createElement(Box, {
    sx: {
      p: 3,
      height: '100%'
    }
  }, children))));
};

var Persist = function Persist(_ref) {
  var _ref$isSessionStorage = _ref.isSessionStorage,
      isSessionStorage = _ref$isSessionStorage === void 0 ? true : _ref$isSessionStorage,
      name = _ref.name,
      props = _objectWithoutPropertiesLoose(_ref, ["isSessionStorage", "name"]);

  return (// @ts-ignore
    React__default.createElement(Persist$1, Object.assign({
      isSessionStorage: isSessionStorage,
      name: name
    }, props))
  );
};

var INTERNAL_ONLY_FORM_INFO = /*#__PURE__*/React__default.createContext({
  prefix: ''
});
var Provider = INTERNAL_ONLY_FORM_INFO.Provider;
var ErrorSummary = function ErrorSummary(_ref) {
  var _ref$globalErrors = _ref.globalErrors,
      globalErrors = _ref$globalErrors === void 0 ? {} : _ref$globalErrors;

  var _React$useState = React__default.useState(0),
      lastHandled = _React$useState[0],
      setLastHandled = _React$useState[1];

  var errorContainer = React__default.useRef(null);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors,
      submitCount = _useFormikContext.submitCount,
      isValid = _useFormikContext.isValid;

  React__default.useEffect(function () {
    if (submitCount > lastHandled && !isValid) {
      var _errorContainer$curre;

      setLastHandled(submitCount);
      (_errorContainer$curre = errorContainer.current) === null || _errorContainer$curre === void 0 ? void 0 : _errorContainer$curre.focus();
    }
  }, [submitCount, lastHandled, isValid, errorContainer]);
  var summaryErrors = Object.assign({}, errors, globalErrors);

  var flattenObject = function flattenObject(obj, prefix) {
    if (prefix === void 0) {
      prefix = '';
    }

    return Object.keys(obj).reduce(function (acc, k) {
      if (obj[k] == null) return acc;
      var pre = prefix.length ? prefix + '.' : '';
      if (typeof obj[k] === 'object') Object.assign(acc, flattenObject(obj[k], pre + k));else acc[pre + k] = obj[k];
      return acc;
    }, {});
  };

  var errorListing = Object.entries(flattenObject(summaryErrors));
  var titleId = prefix + "-error-summary-title";
  if (!errorListing.length) return null;
  var styles = {
    border: '1px solid',
    borderRadius: 'rounded',
    mb: 3,
    maxWidth: 416,
    borderColor: 'danger.base',
    ':focus': {
      borderColor: 'danger.d1'
    }
  };
  var _errorListing$ = errorListing[0],
      key = _errorListing$[0];
  var message = {
    single: "There is 1 error that needs to be correct before proceeding.",
    multiple: "There are " + errorListing.length + " errors that need to be correct before proceeding."
  };
  return jsx(Box, {
    p: 3,
    tabIndex: -1,
    role: "alert",
    "aria-labelledby": titleId,
    sx: styles,
    ref: errorContainer
  }, jsx(Heading, {
    id: titleId,
    variant: "h4",
    sx: {
      mb: 1
    },
    as: "h2"
  }, "Error Summary"), errorListing.length > 1 ? message.multiple : message.single, "\xA0", jsx("a", {
    sx: {
      color: 'primary.base',
      ':hover': {
        color: 'primary.d1'
      }
    },
    href: "#" + prefix + "-" + key,
    onClick: function onClick(e) {
      e.preventDefault();
      var inputElement = document.getElementById(prefix + "-" + key);

      if (!inputElement) {
        console.warn(inputElement + " is missing from the dom");
        return;
      }

      inputElement.focus();
    }
  }, "Fix now."));
}; // // TODO: modify the validation schema to be form level
// // you could do this by swalling the validation schema on the
// // form level and then passing it to the fields using
// // yup.reach
// Apparently forward ref is needed here because
// some developers need access to the formik bag externally

var Form = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      _ref2$showSummary = _ref2.showSummary,
      showSummary = _ref2$showSummary === void 0 ? true : _ref2$showSummary,
      _ref2$formProps = _ref2.formProps,
      formProps = _ref2$formProps === void 0 ? {} : _ref2$formProps,
      _ref2$validateOnBlur = _ref2.validateOnBlur,
      validateOnBlur = _ref2$validateOnBlur === void 0 ? false : _ref2$validateOnBlur,
      _ref2$validateOnMount = _ref2.validateOnMount,
      validateOnMount = _ref2$validateOnMount === void 0 ? false : _ref2$validateOnMount,
      _ref2$validateOnChang = _ref2.validateOnChange,
      validateOnChange = _ref2$validateOnChang === void 0 ? false : _ref2$validateOnChang,
      _ref2$onSubmit = _ref2.onSubmit,
      onSubmit = _ref2$onSubmit === void 0 ? function () {} : _ref2$onSubmit,
      validationSchema = _ref2.validationSchema,
      rest = _objectWithoutPropertiesLoose(_ref2, ["children", "showSummary", "formProps", "validateOnBlur", "validateOnMount", "validateOnChange", "onSubmit", "validationSchema"]);

  var prefix = React__default.useMemo(function () {
    return v4();
  }, []);

  var handleSubmit = function handleSubmit(values, helpers) {
    var newValues = values;
    var schema = validationSchema;

    if (schema) {
      newValues = schema.validateSync(values);
    }

    onSubmit(newValues, helpers);
  };

  return jsx(Provider, {
    value: {
      prefix: prefix
    }
  }, jsx(Formik, Object.assign({}, rest, {
    onSubmit: handleSubmit,
    innerRef: ref,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount,
    validationSchema: validationSchema
  }), jsx(Form$1, Object.assign({
    noValidate: true
  }, formProps), showSummary ? jsx(ErrorSummary, null) : jsx(VisuallyHidden, null, jsx(ErrorSummary, null)), children)));
});

var InputError = function InputError(_ref) {
  var errorMessage = _ref.errorMessage,
      id = _ref.id;
  if (!errorMessage) return null;
  return React__default.createElement(Flex, {
    id: id,
    sx: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      mt: '6px'
    }
  }, React__default.createElement(Icon, {
    size: "sm",
    sx: {
      mr: 1,
      ml: '-1px'
    },
    variant: "color-danger",
    "aria-hidden": "true"
  }), React__default.createElement(VisuallyHidden, null, "Error:"), React__default.createElement(Box, {
    sx: {
      color: 'danger.d1',
      fontWeight: 500,
      variant: 'text.small'
    }
  }, errorMessage));
};

var InputBox = function InputBox(_ref) {
  var hasError = _ref.hasError,
      props = _objectWithoutPropertiesLoose(_ref, ["hasError"]);

  return React__default.createElement(Box, Object.assign({
    variant: hasError ? 'inputContainer.boxError' : 'inputContainer.box'
  }, props));
};
var InputFieldSet = function InputFieldSet(_ref2) {
  var hasError = _ref2.hasError,
      props = _objectWithoutPropertiesLoose(_ref2, ["hasError"]);

  return React__default.createElement(Box, Object.assign({
    as: "fieldset",
    variant: hasError ? 'inputContainer.fieldsetError' : 'inputContainer.fieldset'
  }, props));
};

var Prefix = function Prefix(_ref) {
  var inputElement = _ref.inputElement,
      hasError = _ref.hasError,
      isReadonly = _ref.isReadonly,
      props = _objectWithoutPropertiesLoose(_ref, ["inputElement", "hasError", "isReadonly"]);

  var className = [hasError ? 'input-has-error' : '', isReadonly ? 'read-only' : ''].join(' ');
  return jsx(Box, Object.assign({
    className: className,
    variant: "inputContainer.prefix",
    onClick: function onClick() {
      var _inputElement$current;

      return (_inputElement$current = inputElement.current) === null || _inputElement$current === void 0 ? void 0 : _inputElement$current.focus();
    }
  }, props));
};
var Suffix = function Suffix(_ref2) {
  var hasError = _ref2.hasError,
      inputElement = _ref2.inputElement,
      isReadonly = _ref2.isReadonly,
      props = _objectWithoutPropertiesLoose(_ref2, ["hasError", "inputElement", "isReadonly"]);

  var className = [hasError ? 'input-has-error' : '', isReadonly ? 'read-only' : ''].join(' ');
  return jsx(Box, Object.assign({
    className: className,
    variant: "inputContainer.suffix",
    onClick: function onClick() {
      var _inputElement$current2;

      return (_inputElement$current2 = inputElement.current) === null || _inputElement$current2 === void 0 ? void 0 : _inputElement$current2.focus();
    }
  }, props));
};

var InputContainer = function InputContainer(_ref3) {
  var hasError = _ref3.hasError,
      size = _ref3.size,
      prefix = _ref3.prefix,
      suffix = _ref3.suffix,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? '100%' : _ref3$width,
      sx = _ref3.sx,
      _ref3$readOnly = _ref3.readOnly,
      readOnly = _ref3$readOnly === void 0 ? false : _ref3$readOnly,
      name = _ref3.name,
      rest = _objectWithoutPropertiesLoose(_ref3, ["hasError", "size", "prefix", "suffix", "width", "sx", "readOnly", "name"]);

  var inputRef = React__default.createRef();
  var classNames = [prefix ? 'input-prefix' : '', suffix ? 'input-suffix' : '', hasError ? 'input-has-error' : '', readOnly ? 'read-only' : ''].join(' ');
  var columns = [prefix ? 'max-content' : undefined, '1fr', suffix ? 'max-content' : undefined].filter(Boolean).join(' ');
  return jsx(Grid, {
    gap: 0,
    sx: _extends({
      gridTemplateColumns: columns,
      width: size ? "calc(" + size + "ch + 40px)" : width,
      boxSizing: 'border-box',
      pt: 1
    }, sx)
  }, prefix && jsx(Prefix, {
    isReadonly: readOnly,
    hasError: hasError,
    inputElement: inputRef
  }, prefix), jsx(Box, Object.assign({
    variant: "inputContainer.base",
    ref: inputRef,
    className: classNames,
    "aria-readonly": readOnly,
    // @ts-ignore
    readOnly: readOnly,

    /**
    //@ts-ignore */
    name: name,
    "aria-invalid": hasError
  }, rest)), suffix && jsx(Suffix, {
    isReadonly: readOnly,
    hasError: hasError,
    inputElement: inputRef
  }, suffix));
};

var placementMap = function placementMap(placement) {
  switch (placement) {
    case 'top':
      return {
        bottom: '-4px'
      };

    case 'bottom':
      return {
        top: '-4px'
      };

    case 'left':
      return {
        right: '-4px'
      };

    case 'right':
      return {
        left: '-4px'
      };

    default:
      return {
        left: '-4px'
      };
  }
};

var Arrow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'right' : _ref$placement,
      props = _objectWithoutPropertiesLoose(_ref, ["placement"]);

  return React__default.createElement(Box, Object.assign({
    ref: ref,
    sx: _extends(_extends({
      position: 'absolute',
      width: '10px',
      height: '10px',
      zIndex: '-1'
    }, placementMap(placement)), {}, {
      '::after': {
        position: 'absolute',
        width: '10px',
        height: '10px',
        zIndex: '-1',
        content: '""',
        transform: 'rotate(45deg)',
        bg: 'primary.l3'
      }
    })
  }, props, {
    "data-popper-arrow": true
  }));
});

var Tooltip = function Tooltip(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position,
      children = _ref.children;

  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Manager, null, React__default.createElement(Reference, null, function (_ref2) {
    var ref = _ref2.ref;
    return React__default.createElement(Icon, {
      ref: ref,
      variant: "color-question",
      color: "primary.base",
      onClick: function onClick() {
        return setVisible(!visible);
      },
      size: "sm",
      sx: {
        ml: 1
      }
    });
  }), visible ? React__default.createElement(Popper, {
    placement: position,
    // @ts-ignore
    eventsEnabled: false
  }, function (_ref3) {
    var ref = _ref3.ref,
        style = _ref3.style,
        placement = _ref3.placement,
        arrowProps = _ref3.arrowProps;
    return React__default.createElement(Box, Object.assign({
      role: "tooltip"
    }, {
      ref: ref,
      style: style
    }, {
      "data-placement": placement,
      sx: {
        bg: 'primary.l3',
        color: '#3d3d3d',
        py: 1,
        px: 2,
        fontSize: 2,
        borderRadius: 'rounded',
        boxShadow: 1
      }
    }), children, React__default.createElement(Arrow, Object.assign({}, arrowProps, {
      placement: placement || 'right'
    })));
  }) : null));
};

var TextInput = function TextInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "type", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    hasError: hasError,
    id: inputId,
    type: type,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", {
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputContainer, Object.assign({
    as: "input"
  }, options, props, field)), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }));
};

var SecretInput = function SecretInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      children = _ref.children,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "children", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useState = React__default.useState(false),
      isVisible = _React$useState[0],
      setVisible = _React$useState[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    hasError: hasError,
    id: inputId,
    type: isVisible ? 'text' : 'password',
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx(Flex, {
    sx: {
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    }
  }, jsx("div", null, jsx("label", {
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description)), jsx(Button, {
    sx: {
      height: '28px',
      width: '30px',
      minHeight: '0',
      mb: -1,
      p: 0
    },
    onClick: function onClick() {
      return setVisible(!isVisible);
    },
    tabIndex: -1,
    type: "button",
    variant: "ghost",
    "aria-pressed": isVisible
  }, jsx(Icon, {
    size: "sm",
    variant: isVisible ? 'eye-closed' : 'eye-open',
    title: "Show password"
  }))), jsx(InputContainer, Object.assign({
    as: "input"
  }, options, props, field)), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }), React__default.Children.map(children, function (child) {
    return React__default.cloneElement(child, {
      inputId: inputId,
      name: name
    });
  }));
};

var NumberInput = function NumberInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "variant", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    hasError: hasError,
    id: inputId,
    spellCheck: false,
    pattern: '[0-9]*',
    type: variant,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", {
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputContainer, Object.assign({
    as: "input",
    inputMode: "numeric"
  }, options, props, field)), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }));
};

var parseValue = function parseValue(value) {
  if (isNaN(value)) return '';
  var fixed = value.toFixed(2);
  return fixed.replace('.00', '');
};

var PercentageInput = function PercentageInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "variant", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var initialValue = parseFloat(field.value) * 100;

  var _useState = useState(parseValue(initialValue)),
      value = _useState[0],
      setValue = _useState[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    hasError: hasError,
    id: inputId,
    spellCheck: false,
    pattern: '[0-9]*',
    type: variant,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", {
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputContainer, Object.assign({
    as: "input",
    inputMode: "numeric"
  }, options, props, field, {
    value: value,
    onChange: function onChange(e) {
      setValue(e.target.value);
      var percent = parseFloat(e.target.value) / 100 || '';
      helpers.setValue(percent);
    }
  })), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }));
};

var TextArea = function TextArea(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      maxLength = _ref.maxLength,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "maxLength", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useState = React__default.useState(false),
      showLength = _React$useState[0],
      toggleLength = _React$useState[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  React__default.useEffect(function () {
    if (!maxLength) return;
    var criticalPercent = maxLength - 0.25 * maxLength;
    if (field.value && field.value.length >= criticalPercent) toggleLength(true);else if (showLength) toggleLength(false);
  }, [field.value]);
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    hasError: hasError,
    id: inputId,
    maxLength: maxLength,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", {
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputContainer, Object.assign({
    as: "textarea"
  }, options, field, props)), jsx(Grid, {
    columns: [1, '1fr max-content'],
    sx: {
      alignItems: 'center'
    }
  }, jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }), maxLength && showLength && jsx("div", {
    "aria-live": "polite",
    role: "status",
    sx: {
      variant: 'text.small',
      color: 'danger.base',
      fontWeight: 500
    }
  }, maxLength - field.value.length, jsx("span", null, " "), "remaining characters")));
};

var DateInput = function DateInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      tooltip = _ref.tooltip,
      description = _ref.description,
      autoComplete = _ref.autoComplete,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly;

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var fieldValue = field.value || '--';
  var yearId = inputId + "-year";
  var dayId = inputId + "-day";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };

  var _React$useMemo = React__default.useMemo(function () {
    var date = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.split('-');
    return {
      monthValue: date[1],
      dayValue: date[2],
      yearValue: date[0]
    };
  }, [fieldValue]),
      monthValue = _React$useMemo.monthValue,
      yearValue = _React$useMemo.yearValue,
      dayValue = _React$useMemo.dayValue;

  return React__default.createElement(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), React__default.createElement("legend", null, label, tooltip && React__default.createElement(Tooltip, null, tooltip)), React__default.createElement(Box, {
    sx: {
      clear: 'left'
    }
  }), description && React__default.createElement(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), React__default.createElement(Box, {
    sx: {
      mt: 1,
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'row nowrap',
      '& label': {
        fontSize: 1
      }
    }
  }, React__default.createElement(Box, {
    sx: {
      mr: 2
    }
  }, React__default.createElement("label", {
    htmlFor: inputId
  }, "Month"), React__default.createElement(InputContainer, {
    as: "input",
    readOnly: readOnly,
    id: inputId,
    inputMode: "numeric",
    name: name + ".month",
    placeholder: "MM",
    size: 2,
    maxLength: 2,
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue(yearValue + "-" + e.target.value + "-" + dayValue);
    },
    value: monthValue,
    hasError: false
  })), React__default.createElement(Box, {
    sx: {
      mr: 2
    }
  }, React__default.createElement("label", {
    htmlFor: dayId
  }, "Day"), React__default.createElement(InputContainer, {
    as: "input",
    id: dayId,
    readOnly: readOnly,
    placeholder: "DD",
    inputMode: "numeric",
    name: name + ".day",
    size: 2,
    maxLength: 2,
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue(yearValue + "-" + monthValue + "-" + e.target.value);
    },
    value: dayValue,
    hasError: false
  })), React__default.createElement(Box, {
    sx: {
      mr: 2
    }
  }, React__default.createElement("label", {
    htmlFor: yearId
  }, "Year"), React__default.createElement(InputContainer, {
    as: "input",
    id: yearId,
    readOnly: readOnly,
    placeholder: "YYYY",
    inputMode: "numeric",
    name: name + ".year",
    size: 4,
    maxLength: 4,
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue(e.target.value + "-" + monthValue + "-" + dayValue);
    },
    value: yearValue,
    hasError: false
  }))), React__default.createElement(InputError, {
    id: errorId,
    errorMessage: meta.error
  }));
};

var SelectSearch = function SelectSearch(props) {
  return React__default.createElement(Box, {
    sx: {
      '& div': {
        px: 0
      },
      '& i': {
        mr: '-2px',
        fontSize: '21px'
      },
      mx: 2,
      mb: 2
    }
  }, React__default.createElement(InputContainer, Object.assign({
    as: "input",
    type: "search",
    placeholder: "Search",
    autoCapitalize: "none",
    autoComplete: "off",
    // @ts-ignore
    prefix: React__default.createElement(Icon, {
      variant: "search",
      color: "primary.base",
      sx: {
        width: 20,
        height: 20,
        ml: 1,
        mt: 1
      }
    })
  }, props)));
};

var SingleSelect = function SingleSelect(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      items = _ref.items,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select' : _ref$placeholder,
      _ref$allowSearch = _ref.allowSearch,
      allowSearch = _ref$allowSearch === void 0 ? false : _ref$allowSearch,
      _ref$dangerouslyOnCha = _ref.dangerouslyOnChange,
      dangerouslyOnChange = _ref$dangerouslyOnCha === void 0 ? function () {} : _ref$dangerouslyOnCha,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      tooltip = _ref.tooltip;

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var downshiftRef = React__default.useRef();
  var selectValueItem = React__default.useMemo(function () {
    if (!field.value) return undefined;
    return items.find(function (item) {
      return item.value === field.value.toString();
    });
  }, [field.value, items]);
  React__default.useEffect(function () {
    var _downshiftRef$current;

    if (!allowSearch) (_downshiftRef$current = downshiftRef.current) === null || _downshiftRef$current === void 0 ? void 0 : _downshiftRef$current._rootNode.removeAttribute('role');
  }, [downshiftRef, allowSearch]);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var inputId = prefix + "-" + name;
  var labelId = inputId + "-label";
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var hasError = Boolean(meta.error);
  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };

  var getItems = function getItems(filter) {
    return filter ? matchSorter(items, filter, {
      keys: ['name']
    }) : items;
  }; // TODO this might fail if we have only items?


  return jsx(InputBox, {
    hasError: hasError,
    sx: sx
  }, jsx(Downshift, {
    ref: downshiftRef,
    itemToString: function itemToString(item) {
      var _item$item, _item$item$props;

      return (item === null || item === void 0 ? void 0 : item.item) ? item === null || item === void 0 ? void 0 : (_item$item = item.item) === null || _item$item === void 0 ? void 0 : (_item$item$props = _item$item.props) === null || _item$item$props === void 0 ? void 0 : _item$item$props.children : item === null || item === void 0 ? void 0 : item.name;
    },
    stateReducer: function stateReducer(state, changes) {
      var _changes$selectedItem;

      switch (changes.type) {
        case Downshift.stateChangeTypes.keyDownEnter:
        case Downshift.stateChangeTypes.keyDownSpaceButton:
        case Downshift.stateChangeTypes.clickItem:
          dangerouslyOnChange((_changes$selectedItem = changes.selectedItem) === null || _changes$selectedItem === void 0 ? void 0 : _changes$selectedItem.value);
          return _extends(_extends({}, changes), {}, {
            highlightedIndex: state.highlightedIndex
          });

        default:
          return changes;
      }
    },
    selectedItem: selectValueItem || null,
    onSelect: function onSelect(selectedItem) {
      return helpers.setValue(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
    },
    labelId: labelId,
    inputId: inputId,
    // @ts-ignore
    items: items
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        selectedItem = _ref2.selectedItem,
        getInputProps = _ref2.getInputProps,
        getToggleButtonProps = _ref2.getToggleButtonProps,
        getLabelProps = _ref2.getLabelProps,
        getMenuProps = _ref2.getMenuProps,
        inputValue = _ref2.inputValue,
        highlightedIndex = _ref2.highlightedIndex,
        getItemProps = _ref2.getItemProps;
    var list = allowSearch ? getItems(inputValue) : items;
    var filterList = list.map(function (item, index) {
      return jsx(Box, Object.assign({
        className: [highlightedIndex === index ? 'active' : '', (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value ? 'selected' : ''].join(' '),
        as: "li",
        role: "option",
        variant: "inputContainer.listItem",
        key: item.value.replace(/ /g, '')
      }, getItemProps({
        item: item,
        index: index
      })), item.name || item.item);
    });
    return jsx("div", null, jsx("label", Object.assign({
      id: labelId,
      htmlFor: inputId
    }, getLabelProps({
      htmlFor: inputId,
      id: labelId
    })), label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId
    }, description), jsx(Box, Object.assign({
      className: hasError ? 'input-has-error' : '',
      as: "button",
      "aria-labelledby": labelId,
      type: "button"
    }, options, {
      disabled: readOnly,
      variant: "inputContainer.select",
      sx: {
        width: width
      }
    }, getToggleButtonProps({
      id: inputId
    })), jsx("div", null, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.item) || placeholder), jsx(Icon, {
      variant: "color-triangle",
      color: "primary.base",
      sx: {
        transform: isOpen ? 'rotate(180deg)' : undefined
      }
    })), jsx("div", {
      sx: {
        position: 'relative'
      }
    }, jsx(Box, Object.assign({
      as: "ul",
      variant: "inputContainer.dropzone",
      role: "listbox"
    }, getMenuProps(options), {
      sx: !isOpen ? {
        border: 'none',
        m: 0,
        boxShadow: 0,
        p: 0
      } : {
        width: width,
        zIndex: 99999
      }
    }), jsx("div", {
      sx: !isOpen ? hiddenVisually : {}
    }, allowSearch && jsx(SelectSearch, Object.assign({}, getInputProps())), filterList.length ? filterList : jsx("div", {
      sx: {
        px: 2
      }
    }, "No items found")))), jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    }));
  }));
};

var countriesWithoutStates = ['PR'];
var fillInAddress = function fillInAddress(_ref) {
  var address_components = _ref.address_components;
  var isHomeAddress = address_components.find(function (_ref2) {
    var types = _ref2.types;
    return types.includes('street_number');
  }) != undefined;

  var _ref3 = address_components.find(function (_ref4) {
    var _ref4$types = _ref4.types,
        types = _ref4$types === void 0 ? [] : _ref4$types;
    return types[0] === 'street_number';
  }) || {},
      _ref3$short_name = _ref3.short_name,
      houseNumber = _ref3$short_name === void 0 ? '' : _ref3$short_name;

  var _ref5 = address_components.find(function (_ref6) {
    var _ref6$types = _ref6.types,
        types = _ref6$types === void 0 ? [] : _ref6$types;
    return types[0] === 'route';
  }) || {},
      _ref5$long_name = _ref5.long_name,
      streetName = _ref5$long_name === void 0 ? '' : _ref5$long_name;

  var _ref7 = address_components.find(function (_ref8) {
    var _ref8$types = _ref8.types,
        types = _ref8$types === void 0 ? [] : _ref8$types;
    return types[0] === 'locality';
  }) || {},
      _ref7$long_name = _ref7.long_name,
      city = _ref7$long_name === void 0 ? '' : _ref7$long_name;

  var _ref9 = address_components.find(function (_ref10) {
    var _ref10$types = _ref10.types,
        types = _ref10$types === void 0 ? [] : _ref10$types;
    return types[0] === 'administrative_area_level_1';
  }) || {},
      _ref9$short_name = _ref9.short_name,
      state = _ref9$short_name === void 0 ? '' : _ref9$short_name;

  var _ref11 = address_components.find(function (_ref12) {
    var _ref12$types = _ref12.types,
        types = _ref12$types === void 0 ? [] : _ref12$types;
    return types[0] === 'postal_code';
  }) || {},
      _ref11$long_name = _ref11.long_name,
      zip = _ref11$long_name === void 0 ? '' : _ref11$long_name;

  var _ref13 = address_components.find(function (_ref14) {
    var _ref14$types = _ref14.types,
        types = _ref14$types === void 0 ? [] : _ref14$types;
    return types[0] === 'country';
  }) || {},
      _ref13$short_name = _ref13.short_name,
      country = _ref13$short_name === void 0 ? '' : _ref13$short_name;

  var isCountryWithoutStates = countriesWithoutStates.includes(country);
  return {
    street1: isHomeAddress ? houseNumber + " " + streetName : streetName,
    street2: '',
    city: city,
    state: isCountryWithoutStates ? country : state,
    zip: zip
  };
};
var stateMapping = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};
var stateSelection = /*#__PURE__*/Object.entries(stateMapping).map(function (_ref15) {
  var key = _ref15[0],
      value = _ref15[1];
  return {
    name: value,
    value: key
  };
});

var AddressInput = function AddressInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      autoComplete = _ref.autoComplete,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$statesArray = _ref.statesArray,
      statesArray = _ref$statesArray === void 0 ? stateSelection : _ref$statesArray,
      fieldsLabels = _ref.fieldsLabels;

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var metaError = meta.error;

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var street1Id = inputId + ".street1";
  var descriptionId = street1Id + "-description";
  var fieldValue = field.value || {};
  var defaultLabels = {
    street1: 'Street address (no PO boxes)',
    street2: 'Address line 2 (optional)',
    city: 'City',
    zip: 'Zip / Postal code'
  };

  var labels = _extends(_extends({}, defaultLabels), fieldsLabels);

  var autocomplete = {};

  var handlePlaceChanged = function handlePlaceChanged() {
    // @ts-ignore
    var address = fillInAddress(autocomplete.getPlace());
    helpers.setValue(address);
  };

  var preventEnter = function preventEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };

  useEffect(function () {
    if (window !== undefined) {
      // @ts-ignore
      var _window = window,
          google = _window.google;

      if (google !== undefined) {
        var input = document.getElementById(street1Id);
        var _options = {
          componentRestrictions: {
            country: ['us', 'pr']
          }
        };
        if (input) input.addEventListener('keypress', preventEnter);
        autocomplete = new google.maps.places.Autocomplete(input, _options); // @ts-ignore

        autocomplete.addListener('place_changed', handlePlaceChanged);
        return function () {
          if (input) input.removeEventListener('keypress', preventEnter);
        };
      }
    }

    return function () {};
  }, []);
  var street2Id = inputId + ".street2";
  var cityId = inputId + ".city";
  var stateId = inputId + ".state";
  var zipId = inputId + ".zip";
  var street1ErrorId = street1Id + "-error";
  var street2ErrorId = street2Id + "-error";
  var cityErrorId = cityId + "-error";
  var zipErrorId = zipId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? street1ErrorId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  var street1 = fieldValue.street1,
      street2 = fieldValue.street2,
      city = fieldValue.city,
      state = fieldValue.state,
      zip = fieldValue.zip;
  return React__default.createElement(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), React__default.createElement("legend", {
    onClick: function onClick() {
      var _document$getElementB;

      return (_document$getElementB = document.getElementById(street1Id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
    }
  }, label), React__default.createElement(Box, {
    sx: {
      clear: 'left'
    }
  }), description && React__default.createElement(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), React__default.createElement(Box, null, React__default.createElement(InputBox, null, React__default.createElement("label", {
    htmlFor: street1Id
  }, labels.street1), React__default.createElement(InputContainer, {
    as: "input",
    readOnly: readOnly,
    id: street1Id,
    inputMode: "text",
    name: name + ".street1",
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue({
        street1: e.target.value,
        street2: street2,
        city: city,
        state: state,
        zip: zip
      });
    },
    value: street1,
    hasError: !!(metaError === null || metaError === void 0 ? void 0 : metaError.street1),
    "aria-describedby": !!(metaError === null || metaError === void 0 ? void 0 : metaError.street1) ? street1ErrorId : undefined
  }), React__default.createElement(InputError, {
    id: street1ErrorId,
    errorMessage: metaError === null || metaError === void 0 ? void 0 : metaError.street1
  })), React__default.createElement(InputBox, null, React__default.createElement("label", {
    htmlFor: street2Id
  }, labels.street2), React__default.createElement(InputContainer, {
    as: "input",
    readOnly: readOnly,
    id: street2Id,
    inputMode: "text",
    name: name + ".street2",
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue({
        street1: street1,
        street2: e.target.value,
        city: city,
        state: state,
        zip: zip
      });
    },
    value: street2,
    hasError: !!(metaError === null || metaError === void 0 ? void 0 : metaError.street2),
    "aria-describedby": !!(metaError === null || metaError === void 0 ? void 0 : metaError.street2) ? street2ErrorId : undefined
  }), React__default.createElement(InputError, {
    id: street2ErrorId,
    errorMessage: metaError === null || metaError === void 0 ? void 0 : metaError.street2
  })), React__default.createElement(InputBox, null, React__default.createElement("label", {
    htmlFor: cityId
  }, labels.city), React__default.createElement(InputContainer, {
    as: "input",
    readOnly: readOnly,
    id: cityId,
    inputMode: "text",
    name: name + ".city",
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue({
        street1: street1,
        street2: street2,
        city: e.target.value,
        state: state,
        zip: zip
      });
    },
    sx: {
      maxWidth: '19rem'
    },
    value: city,
    hasError: !!(metaError === null || metaError === void 0 ? void 0 : metaError.city),
    "aria-describedby": !!(metaError === null || metaError === void 0 ? void 0 : metaError.city) ? cityErrorId : undefined
  }), React__default.createElement(InputError, {
    id: cityErrorId,
    errorMessage: metaError === null || metaError === void 0 ? void 0 : metaError.city
  })), React__default.createElement(InputBox, null, React__default.createElement(SingleSelect, {
    label: "State / Territory",
    readOnly: readOnly,
    id: stateId,
    name: name + ".state",
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      helpers.setValue({
        street1: street1,
        street2: street2,
        city: city,
        state: value,
        zip: zip
      });
    },
    sx: {
      mb: 0,
      pb: 0
    },
    items: statesArray,
    width: "250px"
  })), React__default.createElement(InputBox, null, React__default.createElement("label", {
    htmlFor: zipId
  }, labels.zip), React__default.createElement(InputContainer, {
    as: "input",
    readOnly: readOnly,
    id: zipId,
    inputMode: "text",
    name: name + ".zip",
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      helpers.setValue({
        street1: street1,
        street2: street2,
        city: city,
        state: state,
        zip: e.target.value
      });
    },
    value: zip,
    size: 6,
    hasError: !!(metaError === null || metaError === void 0 ? void 0 : metaError.zip),
    "aria-describedby": !!(metaError === null || metaError === void 0 ? void 0 : metaError.zip) ? zipErrorId : undefined
  }), React__default.createElement(InputError, {
    id: zipErrorId,
    errorMessage: metaError === null || metaError === void 0 ? void 0 : metaError.zip
  }))));
};

/* eslint-disable no-nested-ternary */

var SingleSelect$1 = function SingleSelect(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      inputItems = _ref.items,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select' : _ref$placeholder,
      _ref$allowSearch = _ref.allowSearch,
      allowSearch = _ref$allowSearch === void 0 ? false : _ref$allowSearch,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      tooltip = _ref.tooltip;
  var items = inputItems.concat([{
    name: 'Other',
    value: 'other'
  }]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var downshiftRef = React__default.useRef();
  var value = field.value;
  var selectValueItem = React__default.useMemo(function () {
    if (!field.value) return undefined;
    var foundItem = items.find(function (item) {
      return item.value === field.value.toString();
    });
    if (!foundItem) return {
      name: 'Other',
      value: 'other'
    };
    return foundItem;
  }, [field.value, items]);

  var _React$useState = React__default.useState((selectValueItem === null || selectValueItem === void 0 ? void 0 : selectValueItem.value) === 'other'),
      useOther = _React$useState[0],
      setOther = _React$useState[1];

  React__default.useEffect(function () {
    var _downshiftRef$current;

    if (!allowSearch) (_downshiftRef$current = downshiftRef.current) === null || _downshiftRef$current === void 0 ? void 0 : _downshiftRef$current._rootNode.removeAttribute('role');
  }, [downshiftRef, allowSearch]);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var inputId = prefix + "-" + name;
  var labelId = inputId + "-label";
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var hasError = Boolean(meta.error);
  var describedBy = [hasError && !useOther ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var describedByOther = [hasError && useOther ? errorId : undefined];
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  var otherOptions = {
    'aria-describedby': describedByOther.length ? describedByOther.join(' ') : undefined
  };

  var getItems = function getItems(filter) {
    return filter ? matchSorter(items, filter, {
      keys: ['name']
    }) : items;
  }; // TODO this might fail if we have only items?


  return jsx(Grid, {
    gap: [0, 2],
    columns: [1, 'minmax(0, 416px) minmax(0, 416px)']
  }, jsx(InputBox, {
    hasError: hasError && !useOther,
    sx: sx
  }, jsx(Downshift, {
    ref: downshiftRef,
    itemToString: function itemToString(item) {
      var _item$item, _item$item$props;

      return (item === null || item === void 0 ? void 0 : item.item) ? item === null || item === void 0 ? void 0 : (_item$item = item.item) === null || _item$item === void 0 ? void 0 : (_item$item$props = _item$item.props) === null || _item$item$props === void 0 ? void 0 : _item$item$props.children : item === null || item === void 0 ? void 0 : item.name;
    },
    selectedItem: useOther ? {
      value: 'other',
      name: 'Other'
    } : selectValueItem || null,
    onSelect: function onSelect(selectedItem) {
      if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === 'other') {
        setOther(true);
        helpers.setValue('');
      } else {
        setOther(false);
        helpers.setValue(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value);
      }
    },
    labelId: labelId,
    inputId: inputId,
    // @ts-ignore
    items: items
  }, function (_ref2) {
    var isOpen = _ref2.isOpen,
        selectedItem = _ref2.selectedItem,
        getInputProps = _ref2.getInputProps,
        getToggleButtonProps = _ref2.getToggleButtonProps,
        getLabelProps = _ref2.getLabelProps,
        getMenuProps = _ref2.getMenuProps,
        inputValue = _ref2.inputValue,
        highlightedIndex = _ref2.highlightedIndex,
        getItemProps = _ref2.getItemProps;
    var list = allowSearch ? getItems(inputValue) : items;
    var filterList = list.map(function (item, index) {
      return jsx(Box, Object.assign({
        className: [highlightedIndex === index ? 'active' : '', (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value ? 'selected' : ''].join(' '),
        as: "li",
        role: "option",
        variant: "inputContainer.listItem",
        key: item.value.replace(/ /g, '')
      }, getItemProps({
        item: item,
        index: index
      })), item.name || item.item);
    });
    return jsx("div", null, jsx("label", Object.assign({
      id: labelId,
      htmlFor: inputId
    }, getLabelProps({
      htmlFor: inputId,
      id: labelId
    })), label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
      variant: "inputContainer.description",
      id: descriptionId
    }, description), jsx(Box, Object.assign({
      className: hasError && !useOther ? 'input-has-error' : '',
      as: "button",
      "aria-labelledby": labelId,
      type: "button"
    }, options, {
      disabled: readOnly,
      variant: "inputContainer.select",
      sx: {
        width: width
      }
    }, getToggleButtonProps({
      id: inputId
    })), jsx("div", null, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.item) || placeholder), jsx(Icon, {
      variant: "color-triangle",
      sx: {
        transform: isOpen ? 'rotate(180deg)' : undefined
      }
    })), jsx("div", {
      sx: {
        position: 'relative'
      }
    }, jsx(Box, Object.assign({
      as: "ul",
      variant: "inputContainer.dropzone",
      role: "listbox"
    }, getMenuProps(options), {
      sx: !isOpen ? {
        border: 'none',
        m: 0,
        boxShadow: 0,
        p: 0
      } : {
        width: width,
        zIndex: 99999
      }
    }), jsx("div", {
      sx: !isOpen ? hiddenVisually : {}
    }, allowSearch && jsx(SelectSearch, Object.assign({}, getInputProps())), filterList.length ? filterList : jsx("div", {
      sx: {
        px: 2
      }
    }, "No items found")))), !useOther && jsx(InputError, {
      id: errorId,
      errorMessage: meta.error
    }));
  })), useOther && jsx(InputBox, {
    hasError: hasError && useOther,
    sx: sx
  }, jsx("label", {
    htmlFor: inputId + "-other"
  }, label, " (Other)"), jsx(InputContainer, Object.assign({
    as: "input",
    id: inputId + "-other",
    name: name + ".other",
    hasError: hasError && useOther,
    onChange: function onChange(e) {
      helpers.setValue(e.target.value);
    }
  }, otherOptions, {
    value: useOther ? value || '' : ''
  })), useOther && jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  })));
};

var Tag = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var onDismiss = _ref.onDismiss,
      children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      props = _objectWithoutPropertiesLoose(_ref, ["onDismiss", "children", "variant"]);

  return (// @ts-ignore
    React__default.createElement(Box, Object.assign({
      variant: "tag." + variant
    }, props, {
      ref: ref
    }), React__default.createElement("div", {
      sx: {
        display: 'inline-block'
      }
    }, children), onDismiss && React__default.createElement(Button, {
      variant: "ghost",
      sx: {
        fontSize: 0,
        p: 0,
        height: 18,
        minHeight: 'auto',
        ml: '2px',
        color: 'neutral.base'
      },
      onClick: onDismiss,
      "aria-label": "Remove"
    }, React__default.createElement(Icon, {
      variant: "times",
      "aria-hidden": "true",
      role: "presentation",
      size: "sm"
    })))
  );
});

var MultiSelect = function MultiSelect(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      items = _ref.items,
      tooltip = _ref.tooltip;

  var _React$useState = React__default.useState(),
      inputText = _React$useState[0],
      setInputValue = _React$useState[1];

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var selectValueItem = React__default.useMemo(function () {
    if (!field.value) return [];
    return items.filter(function (item) {
      return field.value.includes(item.value);
    });
  }, [field.value, items]);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var inputId = prefix + "-" + name;
  var labelId = inputId + "-label";
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var menuId = inputId + "-menu";
  var hasError = Boolean(meta.error);

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: selectValueItem,
    itemToString: function itemToString(item) {
      return item === null || item === void 0 ? void 0 : item.name;
    },
    onSelectedItemsChange: function onSelectedItemsChange(e) {
      var _e$selectedItems;

      helpers.setValue(((_e$selectedItems = e.selectedItems) === null || _e$selectedItems === void 0 ? void 0 : _e$selectedItems.map(function (x) {
        return x.value;
      })) || []);
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem,
      reset = _useMultipleSelection.reset,
      setSelectedItems = _useMultipleSelection.setSelectedItems,
      selectedItems = _useMultipleSelection.selectedItems;

  useEffect(function () {
    if (!isequal(selectedItems, selectValueItem)) setSelectedItems(selectValueItem);
  }, [selectValueItem]);

  var getFilterItems = function getFilterItems(filterItems) {
    var remainingItems = filterItems.filter(function (item) {
      return !selectedItems.some(function (x) {
        return x.value === item.value;
      });
    });
    if (!inputText) return remainingItems;
    return matchSorter(remainingItems, inputText, {
      keys: ['name']
    });
  };

  var _useSelect = useSelect({
    items: getFilterItems(items),
    menuId: menuId,
    labelId: labelId,
    stateReducer: function stateReducer(state, _ref2) {
      var changes = _ref2.changes,
          type = _ref2.type;

      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          return _extends(_extends({}, changes), {}, {
            isOpen: true,
            highlightedIndex: state.highlightedIndex
          });

        default:
          return changes;
      }
    },
    onStateChange: function onStateChange(_ref3) {
      var type = _ref3.type,
          selectedItem = _ref3.selectedItem;

      switch (type) {
        case useSelect.stateChangeTypes.MenuKeyDownEnter:
        case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          if (selectedItem) {
            addSelectedItem(selectedItem);
          }

          break;
      }
    }
  }),
      isOpen = _useSelect.isOpen,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getLabelProps = _useSelect.getLabelProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps;

  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  var tagList = selectedItems.map(function (selectedItem, index) {
    return jsx(Tag, Object.assign({
      onDismiss: function onDismiss() {
        return removeSelectedItem(selectedItem);
      },
      sx: {
        m: '2px'
      },
      variant: "primary",
      key: selectedItem.value.replace(/ /g, '')
    }, getSelectedItemProps({
      selectedItem: selectedItem,
      index: index
    })), selectedItem.name);
  });
  var filteredList = getFilterItems(items).map(function (item, index) {
    return jsx(Box, Object.assign({
      className: highlightedIndex === index ? 'active' : undefined,
      as: "li",
      role: "option",
      variant: "inputContainer.listItem",
      key: item.value.replace(/ /g, '')
    }, getItemProps({
      item: item,
      index: index
    })), item.name);
  });
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", Object.assign({
    htmlFor: inputId
  }, getLabelProps({
    htmlFor: inputId
  })), label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }), jsx(Box, Object.assign({
    className: hasError ? 'input-has-error' : '',
    as: "button",
    type: "button",
    disabled: readOnly,
    variant: "inputContainer.select",
    sx: {
      width: width
    }
  }, getToggleButtonProps(getDropdownProps({
    preventKeyAction: isOpen,
    id: inputId
  }))), jsx("div", {
    sx: {
      ml: -1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexFlow: 'row wrap'
    }
  }, selectedItems.length ? tagList : jsx("div", {
    sx: {
      p: '2px'
    }
  }, "Select")), jsx(Icon, {
    variant: "color-triangle",
    color: "primary.base",
    sx: {
      transform: isOpen ? 'rotate(180deg)' : undefined,
      width: '40px'
    }
  })), jsx("div", {
    sx: {
      position: 'relative'
    }
  }, jsx(Box, Object.assign({
    as: "ul",
    variant: "inputContainer.dropzone",
    role: "listbox"
  }, getMenuProps(options), {
    sx: !isOpen ? {
      border: 'none',
      m: 0,
      boxShadow: 0,
      p: 0
    } : {}
  }), jsx("div", {
    sx: !isOpen ? hiddenVisually : {}
  }, jsx(SelectSearch, {
    onChange: function onChange(_ref4) {
      var target = _ref4.target;
      return setInputValue(target.value);
    },
    value: inputText,
    "aria-controls": menuId,
    "aria-readOnly": "false",
    "aria-autocomplete": "list",
    "aria-labelledby": labelId
  }), jsx(Box, {
    sx: {
      ml: 2
    }
  }, selectedItems.length !== items.length && jsx(ButtonLink, {
    onClick: function onClick() {
      return setSelectedItems(items);
    },
    sx: {
      mr: 2,
      borderRight: '1px solid',
      borderRightColor: selectedItems.length ? 'neutral.base' : 'transparent',
      pr: 2,
      minHeight: 'auto',
      borderRadius: 0,
      py: 0
    }
  }, "Select All"), Boolean(selectedItems.length) && jsx(ButtonLink, {
    onClick: reset
  }, "Clear")), filteredList.length ? filteredList : jsx("div", {
    sx: {
      px: 2
    }
  }, "No items found")))));
};

var InputCheckbox = function InputCheckbox(_ref) {
  var isChecked = _ref.isChecked,
      rest = _objectWithoutPropertiesLoose(_ref, ["isChecked"]);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var svgProps = _extends({
    'aria-hidden': true,
    focusable: true,
    sx: {
      pointerEvents: 'none'
    },
    height: theme.isAccessibleMode ? 24 : 16,
    width: theme.isAccessibleMode ? 24 : 16,
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg'
  }, rest);

  var fill = 'primary.base';

  if (isChecked) {
    return jsx("svg", Object.assign({}, svgProps), jsx("g", {
      sx: {
        fill: fill
      }
    }, jsx("path", {
      d: "M14,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V2A2,2,0,0,0,14,0Zm-.293,5.207-7,7a1,1,0,0,1-1.414,0l-3-3A1,1,0,1,1,3.707,7.793L6,10.086l6.293-6.293a1,1,0,1,1,1.414,1.414Z"
    })));
  }

  return jsx("svg", Object.assign({}, svgProps), jsx("g", {
    sx: {
      fill: fill
    }
  }, jsx("path", {
    d: "M14,16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2V14A2,2,0,0,1,14,16ZM2,2V14H14V2Z"
  })));
};

var ConfirmInput = function ConfirmInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", Object.assign({
    htmlFor: inputId
  }, options, {
    "aria-invalid": hasError
  }, props, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '25px 1fr',
      py: 1,
      alignItems: 'flex-start',
      cursor: 'pointer'
    }
  }), jsx("input", Object.assign({
    type: "checkbox",
    id: inputId
  }, field, {
    name: name,
    checked: field.value,
    sx: _extends(_extends({}, hiddenVisually), {}, {
      '&:focus + svg': {
        outline: '.25rem solid',
        outlineColor: 'effects.outline'
      }
    })
  })), jsx(InputCheckbox, {
    className: "inputImage",
    hasError: hasError,
    isChecked: Boolean(field.value),
    sx: {
      mt: '2px'
    }
  }), jsx("div", {
    className: "label",
    sx: {
      display: 'inline-block'
    }
  }, label)), jsx("div", {
    className: "descriptionContainer",
    sx: {
      ml: '22px'
    }
  }, description && jsx(Box, {
    sx: {
      ml: 1,
      mt: 1
    },
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  })));
};

var InputRadio = function InputRadio(_ref) {
  var isChecked = _ref.isChecked,
      rest = _objectWithoutPropertiesLoose(_ref, ["isChecked"]);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var svgProps = _extends({
    'aria-hidden': true,
    focusable: true,
    sx: {
      pointerEvents: 'none'
    },
    height: theme.isAccessibleMode ? 24 : 16,
    width: theme.isAccessibleMode ? 24 : 16,
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg'
  }, rest);

  if (isChecked) {
    return jsx("svg", Object.assign({}, svgProps), jsx("g", {
      strokeWidth: "1",
      sx: {
        fill: 'primary.base'
      }
    }, jsx("circle", {
      cx: "8",
      cy: "8",
      r: "3.5",
      stroke: "none"
    }), jsx("path", {
      d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.006,6.006,0,0,0,8,2Z"
    })));
  }

  return jsx("svg", Object.assign({}, svgProps), jsx("g", {
    strokeWidth: "1",
    sx: {
      fill: 'primary.base'
    }
  }, jsx("path", {
    d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.006,6.006,0,0,0,8,2Z"
  })));
};

var RadioInput = function RadioInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      items = _ref.items,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "items", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var errorId = inputId + "-error";
  var descriptionId = inputId + "-fieldsetDescription";
  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), jsx("legend", null, label, tooltip && jsx(Tooltip, null, tooltip)), jsx("div", {
    sx: {
      clear: 'left'
    }
  }), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    errorMessage: meta.error,
    id: errorId
  }), jsx("div", {
    sx: {
      mt: '2px'
    }
  }, items.map(function (x, index) {
    var radioId = index === 0 ? inputId : inputId + "-" + x.value.replace(/ /g, '');
    var isChecked = field.value === x.value;
    var describeId = radioId + "-list-description";
    return jsx("label", {
      key: radioId,
      htmlFor: radioId,
      "aria-invalid": hasError,
      "aria-describedby": x.description ? describeId : undefined,
      sx: {
        display: 'grid',
        gridTemplateColumns: '24px 1fr',
        alignItems: 'flex-start',
        py: 1,
        cursor: 'pointer'
      }
    }, jsx("div", null, jsx("input", Object.assign({
      type: "radio",
      id: radioId
    }, field, props, {
      value: x.value,
      checked: isChecked,
      sx: _extends(_extends({}, hiddenVisually), {}, {
        '&:focus + svg': {
          outline: '.25rem solid',
          outlineColor: 'effects.outline'
        }
      })
    })), jsx(InputRadio, {
      className: "inputImage",
      hasError: hasError,
      isChecked: isChecked,
      sx: {
        mt: '3px',
        ml: '1px'
      }
    })), jsx("div", {
      className: "descriptionContainer",
      sx: {
        pt: '1px'
      }
    }, jsx("div", {
      sx: {
        display: 'inline-block'
      }
    }, x.label), x.description && jsx(Box, {
      variant: "inputContainer.description",
      id: describeId
    }, x.description)));
  })));
};

var CheckboxInput = function CheckboxInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      items = _ref.items,
      tooltip = _ref.tooltip,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "items", "tooltip"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var errorId = inputId + "-error";
  var descriptionId = inputId + "-fieldsetDescription";
  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), jsx("legend", null, label, tooltip && jsx(Tooltip, null, tooltip)), jsx("div", {
    sx: {
      clear: 'left'
    }
  }), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    errorMessage: meta.error,
    id: errorId
  }), jsx("div", {
    sx: {
      mt: '2px'
    }
  }, items.map(function (x, index) {
    var _field$value;

    var checkboxId = index === 0 ? inputId : inputId + "-" + x.value.replace(/ /g, '');
    var isChecked = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.includes(x.value);
    var describeId = checkboxId + "-list-description";
    return jsx("label", {
      key: checkboxId,
      htmlFor: checkboxId,
      "aria-invalid": hasError,
      "aria-describedby": x.description ? describeId : undefined,
      sx: {
        display: 'grid',
        gridTemplateColumns: '24px 1fr',
        py: 1,
        alignItems: 'flex-start',
        cursor: 'pointer'
      }
    }, jsx("div", null, jsx("input", Object.assign({
      type: "checkbox",
      id: checkboxId
    }, field, props, {
      checked: isChecked,
      value: x.value,
      sx: _extends(_extends({}, hiddenVisually), {}, {
        '&:focus + svg': {
          outline: '.25rem solid',
          outlineColor: 'effects.outline'
        }
      })
    })), jsx(InputCheckbox, {
      className: "inputImage",
      hasError: hasError,
      isChecked: isChecked,
      sx: {
        mt: '3px',
        ml: '1px'
      }
    })), jsx("div", {
      className: "descriptionContainer",
      sx: {
        pt: '1px'
      }
    }, jsx("div", {
      sx: {
        display: 'inline-block'
      }
    }, x.label), x.description && jsx(Box, {
      variant: "inputContainer.description",
      id: describeId
    }, x.description)));
  })));
};

var ChoiceInput = function ChoiceInput(_ref) {
  var allowMultiple = _ref.allowMultiple,
      props = _objectWithoutPropertiesLoose(_ref, ["allowMultiple"]);

  if (allowMultiple) return React__default.createElement(CheckboxInput, Object.assign({}, props));
  return React__default.createElement(RadioInput, Object.assign({}, props));
};

var CheckboxItem = function CheckboxItem(_ref) {
  var checkboxId = _ref.checkboxId,
      hasError = _ref.hasError,
      describeId = _ref.describeId,
      isChecked = _ref.isChecked,
      field = _ref.field,
      item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, ["checkboxId", "hasError", "describeId", "isChecked", "field", "item"]);

  return jsx("label", {
    key: checkboxId,
    htmlFor: checkboxId,
    "aria-invalid": hasError,
    "aria-describedby": item.description ? describeId : undefined,
    sx: {
      display: 'grid',
      gridTemplateColumns: '24px 1fr',
      py: 1,
      alignItems: 'flex-start',
      cursor: 'pointer'
    }
  }, jsx("div", null, jsx("input", Object.assign({
    type: "checkbox",
    id: checkboxId
  }, field, props, {
    checked: isChecked,
    value: item.value,
    sx: _extends(_extends({}, hiddenVisually), {}, {
      '&:focus + svg': {
        outline: '.25rem solid',
        outlineColor: 'effects.outline'
      }
    })
  })), jsx(InputCheckbox, {
    className: "inputImage",
    hasError: hasError,
    isChecked: isChecked,
    sx: {
      mt: '3px',
      ml: '1px'
    }
  })), jsx("div", {
    className: "descriptionContainer",
    sx: {
      pt: '1px'
    }
  }, jsx("div", {
    sx: {
      display: 'inline-block'
    }
  }, item.label), item.description && jsx(Box, {
    variant: "inputContainer.description",
    id: describeId
  }, item.description)));
};

var CheckboxWithOther = function CheckboxWithOther(_ref2) {
  var _initialOtherValue;

  var name = _ref2.name,
      label = _ref2.label,
      items = _ref2.items,
      tooltip = _ref2.tooltip,
      readOnly = _ref2.readOnly,
      description = _ref2.description,
      autoComplete = _ref2.autoComplete,
      props = _objectWithoutPropertiesLoose(_ref2, ["name", "label", "items", "tooltip", "readOnly", "description", "autoComplete"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1],
      helpers = _useField[2];

  var initialOtherValue = '';

  if (Array.isArray(field.value) && field.value.length && items.length) {
    var itemsValues = items.map(function (x) {
      return x.value;
    });

    var _field$value$filter = field.value.filter(function (x) {
      return !itemsValues.includes(x);
    });

    initialOtherValue = _field$value$filter[0];
  }

  var hasInitialOtherValue = Boolean((_initialOtherValue = initialOtherValue) === null || _initialOtherValue === void 0 ? void 0 : _initialOtherValue.length);

  var _useState = useState(hasInitialOtherValue),
      isOtherChecked = _useState[0],
      setIsOtherChecked = _useState[1];

  var _useState2 = useState(initialOtherValue || ''),
      otherValue = _useState2[0],
      setOtherValue = _useState2[1];

  useEffect(function () {
    // TODO: this will not work if initial value changes for the second time
    setIsOtherChecked(hasInitialOtherValue);
    setOtherValue(initialOtherValue || '');
  }, [hasInitialOtherValue]);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var errorId = inputId + "-error";
  var otherId = prefix + "-other";
  var descriptionId = inputId + "-fieldsetDescription";
  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), jsx("legend", null, label, tooltip && jsx(Tooltip, null, tooltip)), jsx("div", {
    sx: {
      clear: 'left'
    }
  }), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    errorMessage: meta.error,
    id: errorId
  }), jsx("div", {
    sx: {
      mt: '2px'
    }
  }, items.map(function (x, index) {
    var _field$value;

    var checkboxId = index === 0 ? inputId : inputId + "-" + x.value.replace(/ /g, '');
    var isChecked = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.includes(x.value);
    var describeId = checkboxId + "-list-description";
    return jsx(CheckboxItem, Object.assign({
      key: checkboxId,
      item: x,
      field: field,
      checkboxId: checkboxId,
      describeId: describeId,
      hasError: hasError,
      isChecked: isChecked
    }, props));
  }), jsx(CheckboxItem // @ts-ignore needed for `null` to work
  , Object.assign({
    // @ts-ignore needed for `null` to work
    item: {
      label: 'Other',
      value: null
    },
    field: field,
    checkboxId: inputId + "-other-checkbox",
    describeId: inputId + "-other-checkbox-list-description",
    hasError: hasError,
    isChecked: isOtherChecked,
    onChange: function onChange(e) {
      if (e.target.checked) {
        var _field$value2;

        var otherOrNull = (otherValue === null || otherValue === void 0 ? void 0 : otherValue.length) ? otherValue : null; // check for `.length` ensure that `[null]` is set to value if there is no other values

        helpers.setValue(((_field$value2 = field.value) === null || _field$value2 === void 0 ? void 0 : _field$value2.length) ? field.value.concat([otherOrNull]) : [null]);
      } else {
        helpers.setValue(field.value.filter(function (v) {
          return v !== null && v !== otherValue;
        }));
      }

      setIsOtherChecked(e.target.checked);
    }
  }, props))), isOtherChecked && jsx(InputBox, {
    pl: 24
  }, jsx("label", {
    htmlFor: otherId,
    sx: _extends({}, hiddenVisually)
  }, label, " (Other)"), jsx(InputContainer, Object.assign({
    as: "input",
    id: otherId,
    inputMode: "text",
    readOnly: readOnly,
    name: name + ".other",
    autoComplete: autoComplete,
    onChange: function onChange(e) {
      // filter it out
      var fieldValue = field.value.filter(function (v) {
        return v !== null && v !== otherValue;
      }); // only then set a new value

      setOtherValue(e.target.value); // new Set ensures values to be unique

      var uniqueValues = new Set(fieldValue.concat([e.target.value || null])); // NOTE: DO NOT use [...new Set()] as it creates an array of Sets (possibly TS issue)

      var newValue = Array.from(uniqueValues);
      helpers.setValue(newValue);
    },
    value: otherValue,
    hasError: hasError
  }, props))));
};

var InputCheckbox$1 = function InputCheckbox(_ref) {
  var isChecked = _ref.isChecked,
      rest = _objectWithoutPropertiesLoose(_ref, ["isChecked", "hasError"]);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var id = React__default.useMemo(function () {
    return v4();
  }, []);
  var backgoundVariants = {
    checked: {
      fill: '#00838F'
    },
    unchecked: {
      fill: '#DDDDDD'
    }
  };
  var circleVariants = {
    checked: {
      cx: 22
    },
    unchecked: {
      cx: 10
    }
  };
  var animate = isChecked ? 'checked' : 'unchecked';
  return jsx("svg", Object.assign({
    height: theme.isAccessibleMode ? 32 : 24,
    width: theme.isAccessibleMode ? 40 : 32,
    viewBox: "0 0 32 24",
    focusable: false,
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    // @ts-ignore
    sx: {
      pointerEvents: 'none'
    }
  }, rest), jsx("g", {
    id: id + "-toggle-switch",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, jsx(motion.rect, {
    x: "0",
    y: "2",
    rx: "10",
    width: "32",
    height: "20",
    animate: animate,
    initial: "unchecked",
    variants: backgoundVariants,
    transition: {
      duration: 0.25
    }
  }), jsx(motion.circle, {
    r: "6",
    cy: "12",
    fill: "#FFFFFF",
    animate: animate,
    initial: "unchecked",
    variants: circleVariants,
    transition: {
      duration: 0.25
    }
  })));
};

var ToggleSwitch = function ToggleSwitch(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  return jsx(InputBox, {
    hasError: hasError
  }, jsx("label", Object.assign({
    htmlFor: inputId
  }, options, {
    "aria-invalid": hasError
  }, props, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '43px 1fr',
      py: 1,
      alignItems: 'flex-start',
      cursor: 'pointer'
    }
  }), jsx("input", Object.assign({
    type: "checkbox",
    id: inputId
  }, field, {
    name: name,
    checked: field.value,
    sx: _extends(_extends({}, hiddenVisually), {}, {
      '&:focus + svg': {
        outline: '.25rem solid',
        outlineColor: 'effects.outline'
      }
    })
  })), jsx(InputCheckbox$1, {
    hasError: hasError,
    isChecked: Boolean(field.value)
  }), jsx("div", {
    className: "label",
    sx: {
      display: 'inline-block'
    }
  }, label)), jsx("div", {
    className: "descriptionContainer",
    sx: {
      ml: '22px'
    }
  }, description && jsx(Box, {
    sx: {
      ml: 1,
      mt: 1
    },
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  })));
};

var ApprovalBox = function ApprovalBox(_ref) {
  var isChecked = _ref.isChecked;
  return React__default.createElement(Box, {
    sx: {
      bg: isChecked ? 'success.base' : 'neutral.l4',
      border: '1px solid',
      borderColor: 'neutral.l3',
      borderRadius: 'rounded',
      width: 40,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    title: "Approve"
  }, React__default.createElement(Icon, {
    variant: isChecked ? 'check' : 'check-circle',
    color: isChecked ? 'white' : 'neutral.base'
  }));
};
var DenyBox = function DenyBox(_ref2) {
  var isChecked = _ref2.isChecked;
  return React__default.createElement(Box, {
    sx: {
      bg: isChecked ? 'danger.base' : 'neutral.l4',
      border: '1px solid',
      borderColor: 'neutral.l3',
      borderRadius: 'rounded',
      width: 40,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    title: "Deny"
  }, React__default.createElement(Icon, {
    variant: isChecked ? 'times' : 'times-circle',
    color: isChecked ? 'white' : 'neutral.base'
  }));
};
var MissingBox = function MissingBox(_ref3) {
  var isChecked = _ref3.isChecked;
  return React__default.createElement(Box, {
    sx: {
      bg: isChecked ? 'neutral.base' : 'neutral.l4',
      border: '1px solid',
      borderColor: 'neutral.l3',
      borderRadius: 'rounded',
      width: 40,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    title: "Missing"
  }, React__default.createElement(Icon, {
    variant: isChecked ? 'minus' : 'minus-circle',
    color: isChecked ? 'white' : 'neutral.base'
  }));
};

var RadioInput$1 = function RadioInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      allowMissing = _ref.allowMissing,
      _ref$allowPass = _ref.allowPass,
      allowPass = _ref$allowPass === void 0 ? true : _ref$allowPass,
      _ref$allowFail = _ref.allowFail,
      allowFail = _ref$allowFail === void 0 ? true : _ref$allowFail,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "label", "description", "allowMissing", "allowPass", "allowFail"]);

  var _useField = useField(name),
      field = _useField[0],
      meta = _useField[1];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var errorId = inputId + "-error";
  var descriptionId = inputId + "-fieldsetDescription";
  var describedBy = [hasError ? errorId : undefined, description ? descriptionId : undefined].filter(Boolean);
  var options = {
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };
  var items = [];
  if (allowPass) items.push({
    label: 'Approve',
    value: 'approve'
  });
  if (allowFail) items.push({
    label: 'Deny',
    value: 'deny'
  });
  if (allowMissing) items.push({
    label: 'Missing',
    value: 'missing'
  });
  return jsx(InputFieldSet, Object.assign({
    hasError: hasError
  }, options), jsx(VisuallyHidden, null, jsx("legend", null, label)), jsx("div", {
    sx: {
      clear: 'left'
    }
  }), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description), jsx(InputError, {
    errorMessage: meta.error,
    id: errorId
  }), jsx(Grid, {
    columns: "40px 40px 40px",
    gap: 1,
    sx: {
      mt: '2px'
    }
  }, items.map(function (x, index) {
    var radioId = index === 0 ? inputId : inputId + "-" + x.value.replace(/ /g, '');
    var isChecked = field.value === x.value;
    return jsx("label", {
      key: radioId,
      htmlFor: radioId,
      "aria-invalid": hasError,
      sx: {
        display: 'grid',
        gridTemplateColumns: '24px 1fr',
        alignItems: 'flex-start',
        py: 1,
        cursor: 'pointer'
      }
    }, jsx("div", null, jsx("input", Object.assign({
      type: "radio",
      id: radioId
    }, field, props, {
      value: x.value,
      sx: _extends(_extends({}, hiddenVisually), {}, {
        '&:focus + div': {
          outline: '.25rem solid',
          outlineColor: 'effects.outline'
        }
      })
    })), x.value === 'approve' && jsx(ApprovalBox, {
      isChecked: isChecked
    }), x.value === 'deny' && jsx(DenyBox, {
      isChecked: isChecked
    }), x.value === 'missing' && jsx(MissingBox, {
      isChecked: isChecked
    })), jsx(VisuallyHidden, null, x.label));
  })));
};

/** @jsx jsx */

var Signature = function Signature(_ref) {
  var name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      tooltip = _ref.tooltip;
  var canvasRef = React__default.useRef(null);

  var _React$useState = React__default.useState(),
      pad = _React$useState[0],
      setPad = _React$useState[1];

  var _useField = useField(name),
      meta = _useField[1],
      helpers = _useField[2];

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var hasError = Boolean(meta.error);
  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var errorId = inputId + "-error";
  var isClient = typeof window === 'object';

  var handleResize = function handleResize() {
    var _canvas$getContext;

    var canvas = canvasRef.current;
    if (!canvas || !pad) return;
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    (_canvas$getContext = canvas.getContext('2d')) === null || _canvas$getContext === void 0 ? void 0 : _canvas$getContext.scale(ratio, ratio);
    pad.clear();
  };

  React__default.useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) return;
    var signaturePad = new SignaturePad(canvas, {
      backgroundColor: '#fff'
    });
    setPad(signaturePad);
  }, [canvasRef]);
  React__default.useEffect(function () {
    if (!isClient) return function () {};
    handleResize();
    var debounceSize = debounce(handleResize, 250);
    window.addEventListener('resize', debounceSize);
    return function () {
      return window.removeEventListener('resize', debounceSize);
    };
  }, [pad]);
  var describedBy = [description ? descriptionId : undefined, hasError ? errorId : undefined].filter(Boolean);
  var options = {
    id: inputId,
    'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined
  };

  var saveDrawing = function saveDrawing() {
    var data = pad === null || pad === void 0 ? void 0 : pad.toDataURL();
    helpers.setValue(data);
  };

  return jsx(InputBox, {
    hasError: hasError
  }, jsx("div", null, jsx("label", {
    onClick: function onClick() {
      var _canvasRef$current;

      return (_canvasRef$current = canvasRef.current) === null || _canvasRef$current === void 0 ? void 0 : _canvasRef$current.focus();
    },
    htmlFor: inputId
  }, label), tooltip && jsx(Tooltip, null, tooltip), description && jsx(Box, {
    variant: "inputContainer.description",
    id: descriptionId
  }, description)), jsx("div", {
    sx: {
      position: 'relative'
    }
  }, jsx(Box, Object.assign({
    as: "canvas",
    className: hasError ? 'input-has-error' : '',
    variant: "inputContainer.base",
    tabIndex: 0,
    // @ts-ignore
    ref: canvasRef,
    height: 250,
    onMouseUp: saveDrawing,
    onTouchEnd: saveDrawing,
    width: 400
  }, options, {
    sx: {
      width: '100%',
      height: 250,
      mt: 2,
      bg: 'white'
    }
  })), jsx("div", {
    sx: {
      position: 'absolute',
      left: 16,
      bottom: 16,
      pointerEvents: 'none'
    }
  }, jsx(Icon, {
    variant: "edit",
    color: "neutral.l1"
  }))), jsx("div", {
    sx: {
      display: 'flex',
      alignItems: 'flex-start'
    }
  }, jsx(InputError, {
    id: errorId,
    errorMessage: meta.error
  }), jsx(Button, {
    type: "button",
    variant: "ghost",
    onClick: function onClick() {
      pad === null || pad === void 0 ? void 0 : pad.clear();
      helpers.setValue(undefined);
    },
    sx: {
      color: 'primary.base',
      ml: 'auto'
    }
  }, "Clear Signature")));
};

var sizeVariants$1 = {
  xs: '110px',
  sm: '160px',
  md: '230px',
  lg: '320px',
  xl: '640px'
};

var Loanpal = function Loanpal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "invert", "sx"]);

  return jsx("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 183",
    xmlSpace: "preserve"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$1[x];
      }) : sizeVariants$1[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "Loanpal"), jsx(Box, {
    as: "g",
    sx: {
      fill: invert ? 'text.negative' : 'logo.text'
    }
  }, jsx("path", {
    d: "M10.6,46.8c0-1.4,1.1-2.6,2.6-2.6h5.3c1.4,0,2.6,1.2,2.6,2.6v72.7c0,8.9,1.8,11,9.4,11h29.8\n\t\tc1.5,0,2.6,1.2,2.6,2.6v3.9c0,1.4-1.1,2.6-2.6,2.6H23c-6.7,0-12.4-4.2-12.4-12.7V46.8z"
  }), jsx("path", {
    d: "M187.9,136l41.4-91.7c0.4-0.8,1.1-1.5,2.3-1.5h1.4c1.2,0,1.9,0.7,2.3,1.5l41.1,91.7c0.8,1.8-0.3,3.5-2.3,3.5\n\t\th-5.4c-1.2,0-2-0.8-2.3-1.5l-10.1-22.5h-48.3L198,138c-0.3,0.7-1.1,1.5-2.3,1.5h-5.4C188.2,139.5,187.1,137.8,187.9,136z\n\t\t M252.6,107.1c-6.7-14.8-13.2-29.8-19.9-44.7h-1.1l-19.9,44.7H252.6z"
  }), jsx("path", {
    d: "M304.1,42.8h-3.4c-1.4,0-2.6,1.1-2.6,2.5v91.7c0,1.4,1.2,2.6,2.6,2.6h4.8c1.5,0,2.6-1.2,2.6-2.6V62.9h0.1\n\t\tl60.6,75.9l-0.4-15.7L304.1,42.8z"
  }), jsx("path", {
    d: "M367.9,46.8c0-1.4,1.1-2.6,2.6-2.6h32c16.7,0,30.5,13.6,30.5,30.1c0,16.9-13.8,30.6-30.4,30.6h-17v32\n\t\tc0,1.4-1.2,2.6-2.6,2.6l-13.7,0l-1.4-1.8V46.8z M401.4,88.3c7.6,0,14-6.1,14-14.2c0-7.5-6.4-13.2-14-13.2h-15.8v27.4H401.4z"
  }), jsx("path", {
    d: "M437.7,136L480,44.3c0.4-0.8,1.1-1.5,2.3-1.5h1.4c1.4,0,1.9,0.7,2.3,1.5L528,136c0.8,1.8-0.3,3.5-2.3,3.5\n\t\th-11.8c-2,0-3-0.8-3.9-2.7l-6.7-14.7h-40.7l-6.7,14.7c-0.5,1.4-1.8,2.7-3.9,2.7H440C437.9,139.5,436.9,137.8,437.7,136z M496.5,107\n\t\tl-13.6-30h-0.4l-13.3,30H496.5z"
  }), jsx("path", {
    d: "M547.2,46.8c0-1.4,1.1-2.6,2.6-2.6h12.5c1.4,0,2.6,1.2,2.6,2.6v76.4h34.7c1.5,0,2.6,1.2,2.6,2.6v11.2\n\t\tc0,1.4-1.1,2.6-2.6,2.6h-49.8c-1.5,0-2.6-1.2-2.6-2.6V46.8z"
  })), jsx(Box, {
    as: "g",
    sx: {
      fill: 'logo.icon'
    }
  }, jsx("path", {
    d: "M125.1,42.4c27.3,0,49.2,21.9,49.2,49.2s-21.9,49-49.2,49s-49-21.6-49-49S98,42.4,125.1,42.4z M125.1,131.2\n\t\tc21.6,0,39.6-17.7,39.6-39.3S146.7,52,125.1,52S85.7,70,85.7,91.8C85.7,113.2,103.4,131.2,125.1,131.2z"
  }), jsx("path", {
    d: "M101.2,107.5c0.2-0.1,0.4-0.1,0.6,0c5.3,2.9,9.4,4.3,13.3,5.1c3.7,0.8,7,1.2,10.1,1.2c3.1,0,6.3-0.1,10-1\n\t\tc3.6-0.9,7.9-2.2,13.2-5c0.2-0.1,0.4-0.1,0.6,0c0.4,0.2,0.6,0.6,0.4,1c-2.2,4.6-5.2,8.4-9.4,11.4c-4.3,2.9-9.6,4.7-15,4.5\n\t\tc-5.2-0.2-10.5-1.9-14.9-4.9c-2.2-1.5-4.2-3.2-5.7-5.4c-1.4-2-2.7-4-3.6-6.2C100.8,108.1,100.9,107.7,101.2,107.5z"
  })));
};

var sizeVariants$2 = {
  xs: '32px',
  sm: '50px',
  md: '72px',
  lg: '96px',
  xl: '128px'
};

var LoanpalIcon = function LoanpalIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "sx"]);

  return jsx("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$2[x];
      }) : sizeVariants$2[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "Loanpal"), jsx(Box, {
    as: "g",
    sx: {
      fill: 'logo.icon'
    }
  }, jsx("path", {
    d: "M149.1,63c48.5,0,87.4,38.9,87.4,87.4s-38.9,87-87.4,87s-87-38.4-87-87S100.9,63,149.1,63z M149.1,220.6\n\t\tc38.4,0,70.3-31.4,70.3-69.8s-31.8-70.7-70.3-70.7s-70,31.8-70,70.5C79.1,188.8,110.5,220.6,149.1,220.6z"
  }), jsx("path", {
    d: "M106.6,178.7c0.4-0.2,0.7-0.2,1.1,0c9.4,5.2,16.7,7.6,23.6,9.1c6.6,1.4,12.4,2.1,17.9,2.1\n\t\tc5.5,0,11.2-0.2,17.8-1.8c6.4-1.6,14-3.9,23.4-8.9c0.4-0.2,0.7-0.2,1.1,0c0.7,0.4,1.1,1.1,0.7,1.8c-3.9,8.2-9.2,14.9-16.7,20.3\n\t\tc-7.6,5.2-17.1,8.3-26.6,8c-9.2-0.4-18.7-3.4-26.5-8.7c-3.9-2.7-7.5-5.7-10.1-9.6c-2.5-3.6-4.8-7.1-6.4-11\n\t\tC105.9,179.6,106.1,178.9,106.6,178.7z"
  })));
};

var sizeVariants$3 = {
  xs: '110px',
  sm: '160px',
  md: '230px',
  lg: '320px',
  xl: '640px'
};

var GivePower = function GivePower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "invert", "sx"]);

  return jsx("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612.16 140.79",
    xmlSpace: "preserve"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$3[x];
      }) : sizeVariants$3[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "GivePower"), jsx(Box, {
    as: "g",
    sx: {
      fill: invert ? 'text.negative' : 'logo.icon'
    }
  }, jsx("path", {
    d: "M86.1,122.7c-26.2,7.5-47.5,2.8-55.9.2a1.76,1.76,0,0,0-2,2.6,33.67,33.67,0,0,0,18,13.5l-.1.1a45.42,45.42,0,0,0,12,1.7,57.79,57.79,0,0,0,10.4-1.1,8.22,8.22,0,0,0,3-.9A32,32,0,0,0,88,125.3a1.73,1.73,0,0,0-1.9-2.6",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M65.8,109.7V55.5a6.8,6.8,0,1,0-13.6-.2V96.6a5.73,5.73,0,0,1-7.3,5.5h0c-.1,0-.2-.1-.3-.1l-1.7-.7C27.6,95,16.4,81.3,14.2,64.9A45.32,45.32,0,0,1,57.6,13.8h1.3A45.18,45.18,0,0,1,95.5,85.5a6.61,6.61,0,0,0-.5,6.8,6.91,6.91,0,0,0,6.4,4,6.77,6.77,0,0,0,5.4-2.7,58.64,58.64,0,0,0,11.1-37.7C116.2,21.8,85-3.9,51.2.5L49.4.8C27.7,4.1,9.3,19.3,2.8,40.3-3.9,62.2,1.4,84.2,16.3,99.7a57.19,57.19,0,0,0,12.6,10A58.05,58.05,0,0,0,49,117.1a63.92,63.92,0,0,0,9.9.9,6.87,6.87,0,0,0,6.8-6.8v-1.5",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M154.7,104.7c.3.1.8.4,1.7.7a31.7,31.7,0,0,0,3.3,1.1,26.2,26.2,0,0,0,4.7.9,36,36,0,0,0,5.8.4,29.62,29.62,0,0,0,6.6-.7,14.74,14.74,0,0,0,5.8-2.7,14.52,14.52,0,0,0,4.2-5.4,20.37,20.37,0,0,0,1.6-8.8V89a23.59,23.59,0,0,1-6.5,5,20.91,20.91,0,0,1-10.3,2.4,27.49,27.49,0,0,1-10.1-1.8,23.8,23.8,0,0,1-8-5.1,22.66,22.66,0,0,1-5.2-7.9,28,28,0,0,1-1.9-10.2,26.64,26.64,0,0,1,2-10.3,24.43,24.43,0,0,1,5.6-8.2,25.72,25.72,0,0,1,8.5-5.4,29.37,29.37,0,0,1,10.9-2,31.94,31.94,0,0,1,10.4,1.7,22,22,0,0,1,13.8,13.9,36,36,0,0,1,2,12.5V87.8a37.5,37.5,0,0,1-2.1,13.3,25.43,25.43,0,0,1-5.8,9.1,22.76,22.76,0,0,1-8.9,5.2,36.75,36.75,0,0,1-11.3,1.6,54.43,54.43,0,0,1-7.3-.4c-2.2-.3-4.1-.7-5.8-1.1a36,36,0,0,1-4.2-1.3c-1.1-.4-1.9-.8-2.5-1l3-8.5M173.4,87a15.09,15.09,0,0,0,6.1-1.2,15.64,15.64,0,0,0,4.7-3.2,16.37,16.37,0,0,0,3.1-4.9,16.06,16.06,0,0,0,1.1-6.3,18,18,0,0,0-1.1-6.2,16.88,16.88,0,0,0-3.1-5,14.27,14.27,0,0,0-4.7-3.3,16.36,16.36,0,0,0-12.3,0,12.73,12.73,0,0,0-4.8,3.4,14.83,14.83,0,0,0-3,5,17.39,17.39,0,0,0-1.1,6.1,16.09,16.09,0,0,0,4.1,11.4C165.2,85.6,168.8,87,173.4,87Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M214.1,24.8a6.79,6.79,0,0,1,4.8,11.6,6.79,6.79,0,1,1-9.6-9.6,6.2,6.2,0,0,1,4.8-2m-5.6,27.3a4.67,4.67,0,0,1,1.6-4,7,7,0,0,1,4.4-1.2,10.38,10.38,0,0,1,3.2.4c1,.3,1.6.5,2,.6V96.2H208.5Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M245.6,96.2c-3.1-5.7-5.9-11.1-8.5-16.1s-4.8-9.5-6.6-13.4-3.2-7.2-4.2-9.8a19.29,19.29,0,0,1-1.5-5.1,5,5,0,0,1,1.4-3.5,5.74,5.74,0,0,1,4.2-1.4,10.92,10.92,0,0,1,3.4.4,6.71,6.71,0,0,1,1.5.6q1.95,5.25,4.2,10.8c1.5,3.6,3,7.1,4.5,10.3s2.9,6.2,4.1,8.8,2.3,4.8,3.2,6.5c1.2-2.4,2.6-5.1,4-8.4s2.8-6.4,4.2-9.5,2.6-6,3.6-8.6,1.9-4.5,2.3-5.7a12.33,12.33,0,0,1,2.4-3.9,6,6,0,0,1,4.3-1.4,10,10,0,0,1,4.5.9,20.12,20.12,0,0,1,1.9,1.1c-.4,1.4-1.1,3.3-2,5.7s-2.1,5.1-3.4,8-2.8,6-4.3,9.2-3.1,6.3-4.6,9.4-2.9,5.9-4.3,8.5-2.5,4.8-3.4,6.5H245.6",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M325,92.6c-.5.3-1.3.8-2.5,1.4a30.18,30.18,0,0,1-4.2,1.7,55.17,55.17,0,0,1-5.8,1.4,40.32,40.32,0,0,1-7.2.6A31.34,31.34,0,0,1,295,96a23.56,23.56,0,0,1-14.1-13.1,27,27,0,0,1-2.1-11,29.23,29.23,0,0,1,2-10.8,25.25,25.25,0,0,1,5.6-8.4,25.72,25.72,0,0,1,8.5-5.4,28.31,28.31,0,0,1,10.7-1.9,27.53,27.53,0,0,1,9,1.3,22.89,22.89,0,0,1,6.6,3.5,14.57,14.57,0,0,1,4.1,5.2,15.23,15.23,0,0,1,1.4,6.3,13.77,13.77,0,0,1-1.3,6.2,11.44,11.44,0,0,1-4.5,4.8,27.44,27.44,0,0,1-8.7,3.1,68.34,68.34,0,0,1-14,1.1h-3.7c-1.1,0-2.4-.1-3.7-.1a12,12,0,0,0,4.9,8.1c2.7,2.1,6.6,3.1,11.6,3.1a22.88,22.88,0,0,0,4.7-.4,36.86,36.86,0,0,0,3.9-1q1.65-.6,3-1.2l1.8-.9,4.3,8.1M290.5,69.3c1.5.1,2.9.1,4.3.1h4.1a41.14,41.14,0,0,0,8.7-.7,16.43,16.43,0,0,0,5.2-1.8,5.47,5.47,0,0,0,2.5-2.5,7.17,7.17,0,0,0,.6-2.9,6.1,6.1,0,0,0-3-5.6,15.82,15.82,0,0,0-13.8-.6,14.51,14.51,0,0,0-4.6,3.4,15.9,15.9,0,0,0-2.9,4.9A16.47,16.47,0,0,0,290.5,69.3Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M332,73.8a34.47,34.47,0,0,1,2-12.1,23.15,23.15,0,0,1,5.5-8.8,24,24,0,0,1,8.6-5.5,32.28,32.28,0,0,1,11.1-1.9,26.64,26.64,0,0,1,10.3,2,24.69,24.69,0,0,1,13.7,13.7,29,29,0,0,1,.1,20.9,24.16,24.16,0,0,1-5.3,8.2,24.57,24.57,0,0,1-8,5.4,25.11,25.11,0,0,1-10,1.9,21.22,21.22,0,0,1-9.9-2.2,19.41,19.41,0,0,1-6.8-5.3V116H332V73.8m26.4,13.8a15.09,15.09,0,0,0,6.1-1.2,12.73,12.73,0,0,0,4.8-3.4,14.55,14.55,0,0,0,3.1-5.1,19.11,19.11,0,0,0,1.1-6.4,18,18,0,0,0-1.1-6.2,15.06,15.06,0,0,0-3.1-5,14.69,14.69,0,0,0-4.8-3.3,15.44,15.44,0,0,0-6.1-1.2,15.09,15.09,0,0,0-6.1,1.2,14.94,14.94,0,0,0-4.8,3.2,14.11,14.11,0,0,0-3.1,5,16.56,16.56,0,0,0-1.1,6.4,19.11,19.11,0,0,0,1.1,6.4,16.19,16.19,0,0,0,3.1,5.1,13.94,13.94,0,0,0,4.8,3.4A16.2,16.2,0,0,0,358.4,87.6Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M417.4,45.5a29.08,29.08,0,0,1,10.7,2,24.87,24.87,0,0,1,8.6,5.5,25.86,25.86,0,0,1,7.8,18.7A25.3,25.3,0,0,1,442.4,82a26.7,26.7,0,0,1-5.7,8.3,26.41,26.41,0,0,1-8.6,5.5,29.62,29.62,0,0,1-21.4,0,26.41,26.41,0,0,1-8.6-5.5,25.58,25.58,0,0,1-5.7-8.3,25.3,25.3,0,0,1-2.1-10.3,25.77,25.77,0,0,1,2.1-10.4,26.7,26.7,0,0,1,5.7-8.3,28.17,28.17,0,0,1,8.6-5.5,29.08,29.08,0,0,1,10.7-2m0,42.2a15.93,15.93,0,0,0,6.2-1.2,15.38,15.38,0,0,0,4.9-3.4,16.61,16.61,0,0,0,3.1-5.1,16.06,16.06,0,0,0,1.1-6.3,19.11,19.11,0,0,0-1.1-6.4,17.94,17.94,0,0,0-3.1-5.2,14.35,14.35,0,0,0-4.9-3.4,15.93,15.93,0,0,0-6.2-1.2,15.24,15.24,0,0,0-6.2,1.2,13.94,13.94,0,0,0-4.8,3.4,15,15,0,0,0-3.1,5.2,16.9,16.9,0,0,0-1.1,6.4,18.1,18.1,0,0,0,1.1,6.3,18.81,18.81,0,0,0,3.1,5.1,12.73,12.73,0,0,0,4.8,3.4A15.24,15.24,0,0,0,417.4,87.7Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M460.7,96.2c-3.2-7.5-5.8-13.9-7.9-19.2s-3.7-9.6-4.9-13-2.1-6.1-2.6-8a17.36,17.36,0,0,1-.7-4,5.24,5.24,0,0,1,1.4-3.6,5.42,5.42,0,0,1,4.2-1.6,10.53,10.53,0,0,1,3.4.4c.8.3,1.4.5,1.6.6.8,2.9,1.7,5.9,2.7,9.2s2,6.5,3,9.7S463,73,464,75.9s1.9,5.5,2.7,7.8c.7-2,1.5-4.4,2.3-7s1.7-5.3,2.6-8.1,1.8-5.6,2.6-8.5,1.6-5.6,2.4-8.1a9.09,9.09,0,0,1,2.2-3.9c.9-.9,2.5-1.3,4.6-1.3a12.3,12.3,0,0,1,3.5.5c1,.4,1.7.6,2,.7.9,2.9,1.8,6,2.8,9.3s2,6.4,2.9,9.6,1.9,6.2,2.9,9,1.8,5.4,2.6,7.7c1.7-4.5,3.5-9.5,5.3-14.8s3.5-10.7,5-16.1a11.78,11.78,0,0,1,2.3-4.5,6.1,6.1,0,0,1,4.4-1.4,8.86,8.86,0,0,1,4.3.9c1.1.6,1.7,1,1.9,1.1a75.17,75.17,0,0,1-2.8,8.9c-1.3,3.8-2.8,7.9-4.4,12.3s-3.4,8.9-5.2,13.6-3.6,8.8-5.2,12.5H494.1q-.75-2.1-2.1-6c-.9-2.7-1.9-5.6-2.9-8.7S487,75,486,71.7s-1.9-6.3-2.8-9.1c-.9,2.8-1.8,5.8-2.8,9.1s-2,6.5-3,9.7-2,6-2.8,8.7-1.5,4.7-2.1,6H460.7",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M569.6,92.6c-.5.3-1.3.8-2.5,1.4a30.18,30.18,0,0,1-4.2,1.7,55.17,55.17,0,0,1-5.8,1.4,40.32,40.32,0,0,1-7.2.6A31.34,31.34,0,0,1,539.6,96a23.56,23.56,0,0,1-14.1-13.1,27,27,0,0,1-2.1-11,29.23,29.23,0,0,1,2-10.8,25.25,25.25,0,0,1,5.6-8.4,25.72,25.72,0,0,1,8.5-5.4,28.31,28.31,0,0,1,10.7-1.9,27.53,27.53,0,0,1,9,1.3,22.89,22.89,0,0,1,6.6,3.5,14.57,14.57,0,0,1,4.1,5.2,15.23,15.23,0,0,1,1.4,6.3,13.77,13.77,0,0,1-1.3,6.2,11.44,11.44,0,0,1-4.5,4.8,27.44,27.44,0,0,1-8.7,3.1,68.34,68.34,0,0,1-14,1.1h-3.7c-1.1,0-2.4-.1-3.7-.1a12,12,0,0,0,4.9,8.1C543,87,546.9,88,552,88a22.88,22.88,0,0,0,4.7-.4,36.86,36.86,0,0,0,3.9-1,28.52,28.52,0,0,0,2.9-1.2l1.8-.9,4.3,8.1M535.1,69.3c1.5.1,2.9.1,4.3.1h4.1a41.14,41.14,0,0,0,8.7-.7,16.43,16.43,0,0,0,5.2-1.8,5.47,5.47,0,0,0,2.5-2.5,7.17,7.17,0,0,0,.6-2.9,6.1,6.1,0,0,0-3-5.6,15.82,15.82,0,0,0-13.8-.6,14.51,14.51,0,0,0-4.6,3.4,15.9,15.9,0,0,0-2.9,4.9A16.47,16.47,0,0,0,535.1,69.3Z",
    transform: "translate(0.06 -0.01)"
  }), jsx("path", {
    d: "M577.1,64.5c0-6,1.9-10.7,5.6-14s8.8-5,15.4-5a26.24,26.24,0,0,1,10.1,1.7c2.6,1.1,3.9,2.9,3.9,5.3a6.2,6.2,0,0,1-.9,3.2,7.73,7.73,0,0,1-1.5,2,36.77,36.77,0,0,0-4.1-1.5,19.06,19.06,0,0,0-5.6-.7c-7.7,0-11.5,4.1-11.5,12.2V96.2H577.3V64.5",
    transform: "translate(0.06 -0.01)"
  })));
};

var sizeVariants$4 = {
  xs: '32px',
  sm: '50px',
  md: '72px',
  lg: '96px',
  xl: '128px'
};

var GivePowerIcon = function GivePowerIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "sx"]);

  return jsx("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 588 682",
    xmlSpace: "preserve"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$4[x];
      }) : sizeVariants$4[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "GivePower"), jsx(Box, {
    as: "g",
    sx: {
      fill: 'logo.icon'
    }
  }, jsx("path", {
    d: "M371.9,494.8c-83.2,23.7-150.8,8.7-177.4,0.6c-4.8-1.5-8.9,3.9-6.3,8.1c11.8,19.1,34.6,36.2,57.2,42.8\n\t\tc0,0-0.2,0.2-0.2,0.2c0.7,0,17,5.3,38.2,5.3c0,0,11.6,0.4,33.1-3.4c4.4-0.8,7.3-1.7,9.4-2.7c21.3-7.2,41.6-24.1,52.3-42.8\n\t\tC380.8,498.5,376.8,493.4,371.9,494.8z"
  }), jsx("path", {
    d: "M307.5,453.5v-49.9l0-122.4c0-10.4-7-20-17.3-22c-13.8-2.7-25.9,7.9-25.9,21.2v123.2l0,7.9\n\t\tc0,12-11.5,20.7-23.1,17.4l-0.2,0c-0.3-0.1-0.5-0.2-0.8-0.3l-5.4-2.2c-48.6-19.7-84.3-63.3-91.1-115.3\n\t\tc-11.3-85.8,55.1-159.9,138-162.3c1.4,0,2.8-0.1,4.3-0.1c79.1,0,143.5,64.4,143.5,143.5c0,30.4-9.4,59.5-27.2,84.1\n\t\tc-4.4,6.1-5,14.4-1.6,21.6c4.4,9.4,13.3,12.7,20.2,12.7c4,0,11.6-1.1,17-8.6c25.2-34.7,37.5-76.4,35.3-119.7\n\t\tC467.6,174.2,368.5,92.7,261,106.5c-1.9,0.2-3.8,0.5-5.7,0.8c-68.9,10.8-127.4,58.9-147.8,125.6c-21.2,69.5-4.4,139.4,42.8,188.8\n\t\tc12,12.6,25.6,23.1,40.1,31.8c19.7,11.7,41.2,19.6,64,23.4c10.3,1.7,20.8,2.8,31.5,2.8h0c11.9,0,21.6-9.7,21.6-21.6V453.5z"
  })));
};

var sizeVariants$5 = {
  xs: '110px',
  sm: '160px',
  md: '230px',
  lg: '320px',
  xl: '640px'
};

var GivePower$1 = function GivePower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "invert", "sx"]);

  var id = React__default.useMemo(function () {
    return "gradient-" + v4();
  }, []);
  return jsx("svg", Object.assign({
    height: "87.01",
    width: "357.22",
    viewBox: "0 0 137 37",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$5[x];
      }) : sizeVariants$5[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "GoodLeap"), jsx("defs", null), jsx(Box, {
    as: "g",
    sx: {
      fill: invert ? 'text.negative' : 'neutral.base'
    }
  }, jsx("defs", null, jsx("linearGradient", {
    x1: "0.0441700867%",
    y1: "50.0493315%",
    x2: "99.9990742%",
    y2: "50.0493315%",
    id: id
  }, jsx("stop", {
    stopColor: "#FF8300",
    offset: "41%"
  }), jsx("stop", {
    stopColor: "#FA9F1F",
    offset: "60%"
  }), jsx("stop", {
    stopColor: "#F7B334",
    offset: "76%"
  }))), jsx("path", {
    d: "M51.5063546,11.5800644 C51.379794,11.4131721 51.2493981,11.2500729 51.1228375,11.0945597 L51.0192878,10.9731835 C50.77942,10.7051491 50.5232676,10.451813 50.2522535,10.2145824 L50.2522535,10.2145824 C50.1314859,10.0997412 49.9710602,10.0346492 49.8035384,10.0325181 C49.610261,10.0258953 49.4252649,10.1103393 49.3049661,10.2600985 L49.3049661,10.2600985 L47.893623,12.2286683 L47.893623,12.2286683 C47.8162291,12.3401483 47.7760019,12.4727646 47.7785678,12.6079688 C47.777926,12.7865182 47.8530565,12.9571433 47.9856671,13.0783015 L47.9856671,13.0783015 C48.3125315,13.3794828 48.5987007,13.7211502 48.8370752,14.0948269 C49.2274783,14.7413081 49.4733311,15.4629973 49.5580875,16.211324 C49.5580875,16.3364932 49.5810985,16.4616623 49.5810985,16.5906245 C49.5810985,16.5906245 49.5810985,16.6664846 49.5810985,16.6778636 C49.5810989,17.9752133 49.0597371,19.2193715 48.1318146,20.1363805 C47.2038921,21.0533895 45.9454988,21.5680541 44.6337271,21.5670476 C43.0372866,21.5643014 41.5387205,20.8056293 40.6029618,19.5264107 L35.0266222,11.7583356 C33.4010515,9.51519764 30.7871635,8.17819731 27.9967527,8.16256647 C23.2454783,8.17511772 19.4017205,11.9901917 19.4059648,16.6892427 C19.4059648,16.9775111 19.4059648,17.2619865 19.4481552,17.5426689 C19.449924,17.5603263 19.449924,17.5781135 19.4481552,17.5957709 C19.4788366,17.8802464 19.5248586,18.1571358 19.5823862,18.4340251 C19.5823862,18.4340251 19.5823862,18.4340251 19.5823862,18.4605762 C19.9531634,20.2378847 20.8948386,21.8490716 22.2670063,23.0539057 C22.4001902,23.1910228 22.5781928,23.2770298 22.7694138,23.2966581 C23.0202535,23.2795057 23.2446689,23.1363135 23.3638654,22.9173576 L23.3638654,22.9173576 L24.6256369,21.149817 C24.7121962,21.0416274 24.7606744,20.9084465 24.763703,20.7705165 C24.7634181,20.6070387 24.7003598,20.4497704 24.5872851,20.3305279 L24.5872851,20.3305279 C23.585918,19.3807442 23.0300116,18.0612377 23.0532165,16.6892427 C23.0266128,15.4125698 23.5264434,14.1801552 24.4377135,13.2755378 C25.4647977,12.2296925 26.9091221,11.6900068 28.378857,11.8028917 C29.8485919,11.9157765 31.1913512,12.6695277 32.0428587,13.8596606 L37.6076927,21.6201497 C39.4077584,24.1112631 42.4219979,25.4541982 45.5012407,25.1369645 C48.5804835,24.8197308 51.2501529,22.8912208 52.4924446,20.0866737 C53.7347363,17.2821266 53.3581868,14.0337828 51.5063546,11.5800644 Z"
  }), jsx("path", {
    d: "M46.6282072,8.85289346 C46.6322678,8.68163054 46.5653475,8.5161307 46.4428632,8.39499303 C46.3203788,8.27385537 46.1530392,8.20767086 45.9798723,8.21187555 L45.9798723,8.21187555 C45.3358388,8.13619155 44.6858297,8.12348675 44.0392755,8.17394549 L43.6557584,8.21566855 C41.2276557,8.49640837 39.034532,9.78430187 37.6230334,11.7583356 L32.0581994,19.5188247 C31.2074081,20.8018709 29.7739663,21.5901019 28.2230278,21.6277357 L28.1731706,21.6277357 C27.9869423,21.6405427 27.8151978,21.731685 27.7014445,21.8780741 L27.7014445,21.8780741 C27.7014445,21.8780741 27.6784335,21.9084181 27.6707631,21.9197971 L26.1366945,24.0438802 C26.0114677,24.2097905 25.9755472,24.4255287 26.0403721,24.6223908 C26.105197,24.8192529 26.2626856,24.972696 26.4626841,25.0338546 L26.4972006,25.0338546 C27.3354093,25.1195288 28.1787169,25.1461469 29.0207435,25.1135077 C31.4488777,24.8321315 33.6439449,23.5496829 35.064974,21.5822196 L40.5914562,13.8520746 C41.4648691,12.6645409 42.8230222,11.9179988 44.3039024,11.8114377 L44.3307486,11.8114377 C44.561274,11.8107792 44.7736568,11.6876478 44.8868484,11.4890322 L46.5052909,9.21322898 C46.5832236,9.10872934 46.6261374,8.98272956 46.6282072,8.85289346 L46.6282072,8.85289346 Z",
    fill: "url(#" + id + ")"
  }), jsx("path", {
    d: "M16.6484799,8.66324319 L14.5736521,8.66324319 C14.1500307,8.66324319 13.8066178,9.00288046 13.8066178,9.42184427 L13.8066178,9.97183006 C13.8078723,10.0828262 13.7419811,10.1838349 13.6392119,10.2284571 C13.5364427,10.2730792 13.4166618,10.2526888 13.3348917,10.1766524 C11.9729588,8.97627814 10.2078816,8.32046841 8.38368512,8.33704472 C3.61273165,8.3218727 0,12.012467 0,16.909237 C0,21.806007 3.53602822,25.4131551 8.40669615,25.4131551 C10.6809529,25.4131551 12.7366049,24.4876618 13.8603102,23.0045967 C13.7644309,27.457585 11.9657354,29.6233911 8.37217961,29.6233911 C6.67552996,29.6130421 5.09478586,28.7702465 4.15349085,27.3741389 C3.94371302,27.0628808 3.53120074,26.9568068 3.19469795,27.1275936 C2.70379598,27.3741389 1.96360786,27.7686115 1.46503555,28.0379149 C1.27767803,28.1345446 1.13892464,28.3033349 1.08151839,28.5044545 C1.03055114,28.6883808 1.05537499,28.8847882 1.15055148,29.0506473 C2.68097525,31.5386748 5.42784209,33.0405598 8.37217961,32.999166 C14.3627177,32.999166 17.4001736,29.4299479 17.4001736,22.3977158 L17.4001736,9.40667225 C17.3920182,8.99947541 17.0602035,8.67130885 16.6484799,8.66324319 Z M8.68282851,21.8970391 C5.7527574,21.8970391 3.6740944,19.8336441 3.6740944,16.8750999 C3.63109285,15.5397324 4.14165794,14.2449716 5.08742584,13.2909805 C6.03319375,12.3369895 7.33203069,11.8066163 8.68282851,11.8228167 C11.1450087,11.8228167 13.8066178,13.4045 13.8066178,16.8750999 C13.8066178,20.1370846 11.1603494,21.8970391 8.68282851,21.8970391 Z"
  }), jsx("path", {
    d: "M71.4224008,9.31919866e-06 L69.3437378,9.31919866e-06 C68.9201164,9.31919866e-06 68.5767034,0.339656089 68.5767034,0.758619899 L68.5767034,9.81631684 C68.5754032,9.93246152 68.5046384,10.036805 68.3964772,10.0820624 C68.288316,10.1273198 68.1633192,10.1048879 68.0781311,10.0249321 C66.8892279,8.94392559 65.0828621,8.3218727 63.1192542,8.3218727 C58.286938,8.3218727 54.7815912,11.9062628 54.7815912,16.8409629 C54.7815912,21.7756629 58.3828173,25.4131551 63.157606,25.4131551 C64.9654135,25.4305747 66.7176004,24.7953946 68.0858015,23.6266496 C68.1700391,23.5455812 68.2952674,23.5224848 68.4033877,23.5680757 C68.5115079,23.6136667 68.5813608,23.7190228 68.5805386,23.8352649 L68.5805386,24.3169766 C68.5805386,24.7359404 68.9239516,25.0755776 69.3475729,25.0755776 L71.4262359,25.0755776 C71.8498573,25.0755776 72.1932703,24.7359404 72.1932703,24.3169766 L72.1932703,0.758619899 C72.1932703,0.556767474 72.1119342,0.363237269 71.9672569,0.220862432 C71.8225795,0.0784875949 71.6264946,-0.000990446947 71.4224008,9.31919866e-06 Z M68.5460221,16.8068258 C68.5460221,20.3039768 65.8959185,21.8970391 63.4337383,21.8970391 C60.5995465,21.8970391 58.4480152,19.708475 58.4480152,16.8068258 C58.4480152,13.9051767 60.5420189,11.8228167 63.4337383,11.8228167 C65.9649516,11.8228167 68.5460221,13.5334621 68.5460221,16.8068258 Z"
  }), jsx("rect", {
    x: "75.7216281",
    y: "1.88151913e-05",
    width: "3.60889648",
    height: "25.0565938",
    rx: "0.759363977"
  }), jsx("path", {
    d: "M89.8082134,8.3218727 C84.8953586,8.3218727 81.3324842,11.8910908 81.3324842,16.8068258 C81.3324842,21.7832489 84.8953586,25.3941901 89.8082134,25.3941901 C93.0297576,25.3941901 95.7028722,24.0059501 97.1410615,21.5784266 C97.2511495,21.3875295 97.2721226,21.1587978 97.1985527,20.9514289 C97.1249828,20.7440599 96.9641009,20.5784354 96.7575444,20.4974201 C96.504423,20.402595 96.2474665,20.3115628 95.99051,20.2243237 C95.6606853,20.1067405 95.3308605,19.9929504 95.0202116,19.8677812 C94.7006059,19.7294099 94.326694,19.830552 94.1227815,20.1105335 C93.1454058,21.4384435 91.5636461,22.1978735 89.9040927,22.1359984 C87.4687587,22.1359984 85.6048653,20.7856885 85.0487655,18.6122964 C85.0265177,18.5305296 85.0450383,18.4431714 85.0986227,18.3771301 C85.1536355,18.308862 85.2366414,18.2685111 85.3248978,18.2671329 L97.2752925,18.2671329 C97.6857924,18.2675442 98.0238546,17.9482444 98.0423269,17.5426689 C98.0423269,17.2885375 98.0423269,17.0306131 98.0423269,16.8068258 C98.0423269,11.8114377 94.6558703,8.3218727 89.8082134,8.3218727 Z M85.0564358,15.0354923 C85.6048653,12.9076163 87.4265719,11.5838574 89.8082134,11.5838574 C92.1093164,11.5838574 93.8198029,12.8734792 94.3567269,15.0392853 C94.3754459,15.1228622 94.354578,15.210319 94.3000537,15.2768017 C94.2455293,15.3432844 94.1633094,15.3815249 94.0767594,15.3806558 L85.3364033,15.3806558 C85.2464024,15.3821557 85.1610183,15.3413404 85.106293,15.2706586 C85.052122,15.2048927 85.0335389,15.1172399 85.0564358,15.0354923 L85.0564358,15.0354923 Z"
  }), jsx("path", {
    d: "M116.43581,8.66324319 L114.360982,8.66324319 C113.952207,8.67322996 113.623221,8.99859843 113.613124,9.40287925 L113.613124,9.8618329 C113.61584,9.97211203 113.548348,10.0722359 113.444376,10.1121713 C113.345258,10.1588443 113.227199,10.1391314 113.149068,10.0628622 C111.772885,8.89059612 110.005961,8.26484872 108.190191,8.30670068 C103.319523,8.30670068 99.7834948,11.8910908 99.7834948,16.8257908 C99.7834948,21.7604909 103.400062,25.4131551 108.190191,25.4131551 C110.011215,25.4261805 111.772988,24.7737926 113.137562,23.5811335 C113.217572,23.5058716 113.335225,23.4849866 113.436706,23.5280314 C113.540548,23.5702365 113.607555,23.6711473 113.605453,23.7821628 L113.605453,24.3169766 C113.605323,24.7286444 113.937197,25.065286 114.353312,25.0755776 L116.42814,25.0755776 C116.844254,25.065286 117.175998,24.7286444 117.175998,24.3169766 L117.175998,9.40287925 C117.166092,9.00144098 116.841587,8.67717818 116.43581,8.66324319 Z M113.578607,16.8068258 C113.578607,20.3039768 110.928503,21.8970391 108.466323,21.8970391 C105.612956,21.8970391 103.457589,19.708475 103.457589,16.8068258 C103.408104,15.4758946 103.918856,14.1842547 104.86816,13.2396371 C105.817464,12.2950194 107.120319,11.7820043 108.466323,11.8228167 C111.005207,11.8228167 113.578607,13.5334621 113.578607,16.8068258 L113.578607,16.8068258 Z"
  }), jsx("path", {
    d: "M128.696853,8.3218727 C126.88349,8.29375872 125.127173,8.9486958 123.783999,10.1538943 C123.702042,10.2314197 123.580891,10.2523879 123.477185,10.2069964 C123.373342,10.1647913 123.306336,10.0638805 123.308437,9.95286503 L123.308437,9.40667225 C123.308437,8.98770844 122.965024,8.64807117 122.541403,8.64807117 L120.435894,8.64807117 C120.01978,8.65836285 119.688035,8.99500437 119.688035,9.40667225 L119.688035,32.0547076 C119.688035,32.4663755 120.01978,32.803017 120.435894,32.8133087 L122.541403,32.8133087 C122.965024,32.8133087 123.308437,32.4736714 123.308437,32.0547076 L123.308437,23.8542299 C123.309411,23.7441157 123.375401,23.6447369 123.477185,23.6000985 C123.579716,23.5553525 123.699424,23.5763333 123.780163,23.6532006 C125.140009,24.8253678 126.893454,25.4530227 128.696853,25.4131551 C133.506159,25.4131551 137,21.84773 137,16.928202 C137,12.008674 133.506159,8.3218727 128.696853,8.3218727 Z M133.360422,16.943374 C133.360422,19.8601952 131.312441,21.8970391 128.374699,21.8970391 C125.866497,21.8970391 123.331448,20.1939797 123.331448,16.943374 C123.331448,13.423465 125.947035,11.8228167 128.374699,11.8228167 C131.266418,11.8228167 133.360422,13.9772438 133.360422,16.943374 Z"
  })));
};

var sizeVariants$6 = {
  xs: '60px',
  sm: '72px',
  md: '96px',
  lg: '128px',
  xl: '230px'
};

var GivePowerIcon$1 = function GivePowerIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      sx = _ref.sx,
      invert = _ref.invert,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "sx", "invert"]);

  var id = React__default.useMemo(function () {
    return "gradient-" + v4();
  }, []);
  return jsx("svg", Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.22 87.01",
    xmlSpace: "preserve"
  }, rest, {
    sx: _extends({
      width: Array.isArray(size) ? size.map(function (x) {
        return sizeVariants$6[x];
      }) : sizeVariants$6[size],
      height: 'auto'
    }, sx)
  }), jsx("title", null, "GivePower"), jsx(Box, {
    as: "g",
    sx: {
      fill: invert ? 'text.negative' : 'neutral.base'
    }
  }, jsx("defs", null, jsx("linearGradient", {
    id: id,
    gradientUnits: "userSpaceOnUse",
    x1: "67.84",
    x2: "121.58",
    y1: "43.88",
    y2: "43.88"
  }, jsx("stop", {
    offset: ".22",
    stopColor: "#ff7b00"
  }), jsx("stop", {
    offset: ".51",
    stopColor: "#ff9a11"
  }), jsx("stop", {
    offset: ".76",
    stopColor: "#ffaf1c"
  }))), jsx("path", {
    d: "M134.3 30.53c-.33-.44-.67-.87-1-1.28l-.27-.32a23.24 23.24 0 0 0-2-2 1.72 1.72 0 0 0-1.17-.48 1.59 1.59 0 0 0-1.3.6l-3.68 5.19a1.71 1.71 0 0 0-.3 1 1.68 1.68 0 0 0 .54 1.24 13.53 13.53 0 0 1 2.22 2.68 13.9 13.9 0 0 1 1.88 5.58c0 .33.06.66.06 1v.23a12.89 12.89 0 0 1-12.9 12.89 13 13 0 0 1-10.51-5.38L91.33 31A22.71 22.71 0 0 0 73 21.52 22.46 22.46 0 0 0 50.6 44c0 .76 0 1.51.11 2.25a.71.71 0 0 1 0 .14c.08.75.2 1.48.35 2.21v.07a22.19 22.19 0 0 0 7 12.11 2.12 2.12 0 0 0 1.31.64 1.91 1.91 0 0 0 1.55-1l3.29-4.66a1.67 1.67 0 0 0 .36-1 1.7 1.7 0 0 0-.46-1.16 13 13 0 0 1-4-9.6 12.39 12.39 0 0 1 3.61-9 12.93 12.93 0 0 1 19.83 1.54L98.06 57a22.44 22.44 0 1 0 36.24-26.47z"
  }), jsx("path", {
    className: "icon-gradient",
    d: "M121.58 23.34a1.65 1.65 0 0 0-1.69-1.69 25.73 25.73 0 0 0-5.06-.1l-1 .11A22.46 22.46 0 0 0 98.1 31L83.59 51.46a12.32 12.32 0 0 1-10 5.56h-.13a1.7 1.7 0 0 0-1.23.66s-.06.08-.08.11l-4 5.6A1.68 1.68 0 0 0 69 66h.09a46.35 46.35 0 0 0 6.58.21 22.6 22.6 0 0 0 15.76-9.31l14.41-20.38a13.15 13.15 0 0 1 9.68-5.38h.07a1.67 1.67 0 0 0 1.45-.85l4.22-6a1.64 1.64 0 0 0 .32-.95z",
    fill: "url(#" + id + ")"
  }), jsx("path", {
    d: "M43.41 22.84H38a2 2 0 0 0-2 2v1.45a.73.73 0 0 1-1.23.54 19.14 19.14 0 0 0-12.91-4.85C9.42 21.94 0 31.67 0 44.58S9.22 67 21.92 67c5.93 0 11.29-2.44 14.22-6.35-.25 11.74-4.94 17.45-14.31 17.45a13.32 13.32 0 0 1-11-5.93 1.94 1.94 0 0 0-2.5-.65c-1.28.65-3.21 1.69-4.51 2.4a2 2 0 0 0-1 1.23A1.9 1.9 0 0 0 3 76.59 21.68 21.68 0 0 0 21.83 87c15.62 0 23.54-9.41 23.54-27.95V24.8a2 2 0 0 0-1.96-1.96zM22.64 57.73c-7.64 0-13.06-5.44-13.06-13.24a12.91 12.91 0 0 1 13.06-13.32c6.42 0 13.36 4.17 13.36 13.32 0 8.6-6.9 13.24-13.36 13.24z"
  }), jsx("path", {
    d: "M186.23 0h-5.42a2 2 0 0 0-2 2v23.88a.77.77 0 0 1-1.3.55c-3.1-2.85-7.81-4.49-12.93-4.49-12.6 0-21.74 9.45-21.74 22.46S152.23 67 164.68 67a19.37 19.37 0 0 0 12.85-4.71.76.76 0 0 1 1.29.55v1.27a2 2 0 0 0 2 2h5.42a2 2 0 0 0 2-2V2a2 2 0 0 0-2.01-2zm-7.5 44.31c0 9.22-6.91 13.42-13.33 13.42-7.39 0-13-5.77-13-13.42s5.46-13.14 13-13.14c6.6 0 13.33 4.51 13.33 13.14z"
  })));
};

var Logo = function Logo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["size", "variant"]);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  switch (theme.company) {
    case 'Loanpal':
      return variant === 'base' ? React__default.createElement(Loanpal, Object.assign({
        size: size
      }, rest)) : React__default.createElement(LoanpalIcon, Object.assign({
        size: size
      }, rest));

    case 'GivePower':
      return variant === 'base' ? React__default.createElement(GivePower, Object.assign({
        size: size
      }, rest)) : React__default.createElement(GivePowerIcon, Object.assign({
        size: size
      }, rest));

    case 'GoodLeap':
      return variant === 'base' ? React__default.createElement(GivePower$1, Object.assign({
        size: size
      }, rest)) : React__default.createElement(GivePowerIcon$1, Object.assign({
        size: size
      }, rest));

    default:
      return null;
  }
};

var Modal = function Modal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      isOpen = _ref.isOpen,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'small' : _ref$variant,
      onDismiss = _ref.onDismiss,
      rest = _objectWithoutPropertiesLoose(_ref, ["title", "children", "isOpen", "variant", "onDismiss"]);

  var modalPrefix = React__default.useMemo(function () {
    return v4();
  }, []);
  var titleId = modalPrefix + "-title";
  React__default.useEffect(function () {
    if (typeof window !== 'undefined') {
      Modal$1.setAppElement('#root');
    }
  }, []);
  React__default.useEffect(function () {
    if (!document) return function () {};

    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return function () {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);
  return React__default.createElement(Modal$1, {
    shouldCloseOnOverlayClick: true,
    onRequestClose: onDismiss,
    portalClassName: "lumos-modal",
    isOpen: isOpen,
    aria: {
      labelledby: titleId
    }
  }, React__default.createElement(Box, Object.assign({
    variant: "modal." + variant
  }, rest), React__default.createElement(Box, {
    sx: {
      bg: 'primary.d3',
      height: 56,
      display: 'grid',
      alignItems: 'center',
      px: 3,
      gridTemplateColumns: '1fr 45px',
      color: 'text.negative'
    }
  }, React__default.createElement(Heading, {
    id: titleId,
    variant: "h3"
  }, title), React__default.createElement(Button, {
    onClick: onDismiss,
    variant: "ghost",
    sx: {
      p: 0,
      color: 'text.negative',
      '&:hover': {
        bg: 'primary.d1'
      }
    },
    "aria-label": "Dismiss"
  }, React__default.createElement(Icon, {
    "aria-hidden": "true",
    role: "presentation",
    variant: "times",
    size: "lg"
  }))), React__default.createElement(Box, {
    className: "modal-container",
    sx: {
      p: 3,
      mb: '100px',
      height: '100%',
      bg: 'background.depth.0',
      position: 'relative',
      overflowY: 'auto'
    }
  }, children)));
};

var ModalControls = function ModalControls(_ref) {
  var actions = _ref.actions;

  if (actions.length > 2) {
    console.warn('Modal component given actions array length greater than 3');
  }

  return React__default.createElement(Box, {
    sx: {
      px: [2, 3],
      py: 3,
      position: ['inherit', 'fixed'],
      bottom: 0,
      bg: 'white',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row-reverse',
      flexWrap: 'wrap',
      gridTemplateColumns: '160px 160px',
      gap: 2,
      ml: -3,
      mt: 'auto',
      width: ['calc(100% + 32px)', '100%'],
      borderTop: '1px solid',
      borderColor: 'neutral.l3',
      '& > button': {
        minWidth: ['100%', 180]
      }
    }
  }, React__default.createElement(Global, {
    styles: {
      '.modal-container': {
        height: 'calc(100% - 69px)',
        '@media (max-width: 40em)': {
          height: '100%'
        }
      }
    }
  }), actions.map(function (_ref2, index) {
    var label = _ref2.label,
        variant = _ref2.variant,
        props = _objectWithoutPropertiesLoose(_ref2, ["label", "variant"]);

    var key = ['primary', 'secondary', 'tertiary'];
    var buttonVariant = variant;
    if (!buttonVariant) buttonVariant = index === 0 ? 'primary' : 'secondary';
    return React__default.createElement(React__default.Fragment, {
      key: key[index]
    }, index === 2 && React__default.createElement(Box, {
      key: "empty",
      sx: {
        display: ['none', 'block']
      }
    }), React__default.createElement(Button, Object.assign({
      sx: {
        my: [1, 0],
        mr: index === 2 ? 'auto' : undefined
      },
      variant: buttonVariant
    }, props), label));
  }));
};

var Collapsible = function Collapsible(_ref) {
  var title = _ref.title,
      _ref$initialOpen = _ref.initialOpen,
      initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
      children = _ref.children;
  var id = React__default.useMemo(function () {
    return v4();
  }, []);

  var _React$useState = React__default.useState(initialOpen),
      isOpen = _React$useState[0],
      toggleOpen = _React$useState[1];

  var iconVariant = isOpen ? 'angle-up' : 'angle-down';
  var container = "container-" + id;
  var control = "control-" + id;
  return React__default.createElement(Box, null, React__default.createElement(Button, {
    onClick: function onClick() {
      return toggleOpen(!isOpen);
    },
    id: control,
    "aria-expanded": isOpen,
    variant: "ghost",
    "aria-controls": container,
    sx: {
      minHeight: 32,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      px: 0,
      textTransform: 'none',
      fontSize: 2,
      fontWeight: 400,
      ':hover': {
        bg: 'neutral.l4'
      }
    }
  }, React__default.createElement(Icon, {
    variant: iconVariant,
    sx: {
      color: 'neutral.base',
      mr: 1
    },
    "aria-hidden": true
  }), title), React__default.createElement(Box, {
    id: container,
    "aria-labelledby": control,
    role: "region",
    sx: {
      ml: 4,
      display: isOpen ? 'block' : 'none'
    }
  }, children));
};

var Navbar = function Navbar(_ref) {
  var _ref$logoLink = _ref.logoLink,
      logoLink = _ref$logoLink === void 0 ? '/' : _ref$logoLink,
      navLinks = _ref.navLinks,
      handleLink = _ref.handleLink,
      currentPath = _ref.currentPath,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["logoLink", "navLinks", "handleLink", "currentPath", "children"]);

  var isCurrentPath = function isCurrentPath(path) {
    if (currentPath === '/' && path === '/') return true;
    if (path !== '/') return currentPath.includes(path);
    return false;
  };

  return React__default.createElement(Box, Object.assign({
    as: "nav",
    "aria-label": "Main"
  }, props, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 1440,
      height: 56,
      width: '100%',
      mx: 'auto'
    }
  }), React__default.createElement(Flex, {
    sx: {
      alignItems: 'center'
    }
  }, React__default.createElement(Box, {
    as: "button",
    onClick: function onClick() {
      return handleLink(logoLink);
    },
    sx: {
      mr: [3, 4],
      bg: 'transparent',
      p: 0,
      border: 'none',
      cursor: 'pointer'
    }
  }, React__default.createElement("h1", {
    sx: {
      m: 0,
      p: 0
    }
  }, React__default.createElement(Logo, {
    invert: true,
    size: "sm",
    sx: {
      display: ['none', 'block']
    }
  }), React__default.createElement(Logo, {
    variant: "icon",
    size: "sm",
    invert: true,
    sx: {
      display: ['block', 'none'],
      ml: -2
    }
  }))), navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (_ref2) {
    var to = _ref2.to,
        text = _ref2.text,
        hiddenDesktop = _ref2.hiddenDesktop;
    if (hiddenDesktop) return null;
    return React__default.createElement(Box, {
      as: "button",
      variant: "text.base",
      onClick: function onClick() {
        return handleLink(to);
      },
      sx: {
        color: 'text.negative',
        border: 'none',
        bg: 'transparent',
        borderBottom: '2px solid',
        borderColor: isCurrentPath(to) ? 'logo.icon' : 'transparent',
        textDecoration: 'none',
        fontWeight: 600,
        py: '2px',
        cursor: 'pointer',
        mr: 3,
        ':hover': {
          textDecoration: 'none',
          borderColor: 'secondary.l2'
        }
      }
    }, text);
  })), React__default.createElement(Box, {
    sx: {
      ml: 'auto',
      color: 'text.negative'
    }
  }, children));
};

var mobileToggle = /*#__PURE__*/React__default.createContext({
  isOpen: false,
  toggleOpen: function toggleOpen() {}
});
var useMobileToggle = function useMobileToggle() {
  var _React$useContext = React__default.useContext(mobileToggle),
      isOpen = _React$useContext.isOpen,
      toggleOpen = _React$useContext.toggleOpen;

  return {
    isOpen: isOpen,
    toggleOpen: toggleOpen
  };
};

var MenuText = function MenuText(_ref) {
  var children = _ref.children;
  return jsx(Box, {
    variant: "text.h5",
    sx: {
      color: 'white',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, children);
};

var sidebar = {
  open: {
    height: '100vh',
    minHeight: '-webkit-fill-available'
  },
  closed: {
    height: 56
  }
};

var Navbar$1 = function Navbar(_ref2) {
  var title = _ref2.title,
      navLinks = _ref2.navLinks,
      search = _ref2.search,
      children = _ref2.children,
      handleLink = _ref2.handleLink,
      currentPath = _ref2.currentPath,
      props = _objectWithoutPropertiesLoose(_ref2, ["title", "navLinks", "search", "children", "handleLink", "currentPath"]);

  var _useMobileToggle = useMobileToggle(),
      isOpen = _useMobileToggle.isOpen,
      toggleOpen = _useMobileToggle.toggleOpen;

  var _React$useState = React__default.useState(false),
      isSearching = _React$useState[0],
      toggleSearch = _React$useState[1];

  var isCurrentPath = function isCurrentPath(path) {
    if (currentPath === '/' && path === '/') return true;
    if (path !== '/') return currentPath.includes(path);
    return false;
  };

  React__default.useEffect(function () {
    if (!document) return function () {};

    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return function () {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  var onLinkClick = function onLinkClick(to) {
    toggleOpen(false);
    handleLink(to);
  };

  return jsx(FocusLock, {
    disabled: !isOpen
  }, jsx(Box, Object.assign({
    as: "nav",
    "aria-label": "Main",
    sx: _extends({
      bg: 'primary.d3'
    }, sidebar[isOpen ? 'open' : 'closed'])
  }, props), jsx(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      height: 56,
      py: 1,
      pr: 3,
      pl: 2,
      bg: 'primary.d3',
      position: 'relative',
      mb: 2
    }
  }, !isSearching && jsx(React__default.Fragment, null, jsx(Box, {
    as: "button",
    sx: {
      bg: 'transparent',
      p: 2,
      border: 'none'
    },
    onClick: function onClick() {
      return toggleOpen(!isOpen);
    },
    "aria-expanded": isOpen
  }, jsx(Icon, {
    variant: isOpen ? 'times' : 'menu',
    title: "Main menu",
    color: "white",
    size: "lg"
  })), jsx(Logo, {
    variant: "icon",
    size: "sm",
    invert: true
  }), jsx(MenuText, null, isOpen ? 'Menu' : title)), isSearching && search, search && !isOpen && jsx(Box, {
    as: "button",
    sx: {
      bg: 'transparent',
      p: 2,
      border: 'none',
      ml: 'auto'
    },
    onClick: function onClick() {
      return toggleSearch(!isSearching);
    }
  }, jsx(Icon, {
    variant: isSearching ? 'times' : 'search',
    title: "Search",
    color: "white",
    size: "md"
  }))), isOpen && jsx(React__default.Fragment, null, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (link) {
    return jsx(Box, {
      as: "button",
      onClick: function onClick() {
        return onLinkClick(link.to);
      },
      variant: "text.h5",
      sx: {
        color: 'text.negative',
        display: 'flex',
        alignItems: 'center',
        py: '13px',
        px: 0,
        cursor: 'pointer',
        width: '100%',
        bg: 'transparent',
        border: 'none'
      }
    }, jsx(Box, {
      sx: {
        mx: '10px',
        width: 3,
        bg: isCurrentPath(link.to) ? 'logo.icon' : 'transparent',
        height: 28
      }
    }), jsx(Box, {
      sx: {
        transform: 'translateY(-1px)'
      }
    }, link.text));
  }), children)));
};

var Navbar$2 = function Navbar$2(_ref) {
  var _sx, _sx2;

  var _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? '56em' : _ref$mobileBreakpoint,
      props = _objectWithoutPropertiesLoose(_ref, ["mobileBreakpoint"]);

  var _React$useState = React__default.useState(false),
      isOpen = _React$useState[0],
      toggleOpen = _React$useState[1];

  return React__default.createElement(mobileToggle.Provider, {
    value: {
      isOpen: isOpen,
      toggleOpen: toggleOpen
    }
  }, React__default.createElement(Box, {
    sx: (_sx = {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'sticky',
      top: 0,
      bg: 'primary.d3',
      zIndex: 900,
      px: 3,
      py: 1,
      height: 56
    }, _sx["@media only screen and (max-width: " + mobileBreakpoint + ")"] = {
      display: 'none'
    }, _sx)
  }, React__default.createElement(Navbar, Object.assign({}, props))), React__default.createElement(Box, {
    sx: (_sx2 = {
      display: 'none',
      position: 'sticky',
      top: 0,
      zIndex: 900
    }, _sx2["@media only screen and (max-width: " + mobileBreakpoint + ")"] = {
      display: 'block'
    }, _sx2)
  }, React__default.createElement(Navbar$1, Object.assign({}, props))));
};

var SectionGroup = function SectionGroup(_ref) {
  var title = _ref.title,
      children = _ref.children,
      _ref$isFieldset = _ref.isFieldset,
      isFieldset = _ref$isFieldset === void 0 ? false : _ref$isFieldset,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      description = _ref.description,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "children", "isFieldset", "actions", "description", "sx"]);

  var prefix = React__default.useMemo(function () {
    return v4();
  }, []);
  var titleId = prefix + "-title";
  var descriptionId = prefix + "-description";
  return jsx(Box, Object.assign({
    "aria-labelledby": titleId,
    "aria-describedby": description ? descriptionId : undefined,
    as: isFieldset ? 'fieldset' : 'section',
    sx: _extends({
      border: 'none',
      borderTop: '1px solid',
      borderColor: 'neutral.l3',
      pt: 2,
      pb: 0,
      px: 0
    }, sx)
  }, props), jsx(Heading, {
    id: titleId,
    as: isFieldset ? 'legend' : 'h4',
    sx: {
      mb: 2,
      "float": 'left',
      px: 0
    },
    variant: "h5"
  }, title), jsx("div", {
    sx: {
      clear: 'both'
    }
  }), description && jsx(Box, {
    id: descriptionId
  }, description), children, Boolean(actions.length) && jsx("div", {
    sx: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, actions.map(function (action) {
    return jsx(ButtonLink, {
      onClick: action.onClick
    }, action.title);
  })));
};

var StartHero = function StartHero() {
  var _colors$gradients;

  var _useThemeUI = useThemeUI(),
      colors = _useThemeUI.theme.colors;

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    as: "header",
    sx: {
      display: 'flex',
      '@media screen and (max-width: 80em)': {
        display: 'none'
      },
      maxWidth: 480,
      width: '100%',
      bg: 'primary.d3',
      // @ts-ignore
      background: (colors === null || colors === void 0 ? void 0 : (_colors$gradients = colors.gradients) === null || _colors$gradients === void 0 ? void 0 : _colors$gradients.secondary) || (colors === null || colors === void 0 ? void 0 : colors.primary),
      position: 'relative',
      overflow: 'hidden',
      justifyContent: 'center',
      color: 'text.negative',
      minHeight: '100vh'
    }
  }, React__default.createElement(Box, {
    as: "h1",
    mt: 72
  }, React__default.createElement(Logo, {
    invert: true
  })), React__default.createElement(Logo, {
    "aria-hidden": "true",
    variant: "icon",
    sx: {
      g: {
        fill: 'white'
      },
      transform: 'scale(3.8)',
      width: 300,
      opacity: 0.11,
      position: 'absolute',
      left: -80,
      bottom: 183
    }
  })), React__default.createElement(Box, {
    as: "header",
    sx: {
      display: 'none',
      '@media screen and (max-width: 80em)': {
        display: 'flex'
      },
      bg: 'primary.d3',
      px: 3,
      py: 1,
      height: 56
    }
  }, React__default.createElement(Logo, {
    invert: true,
    size: "sm"
  })));
};

var ButtonControls = function ButtonControls(_ref) {
  var submitMessage = _ref.submitMessage,
      onPrevious = _ref.onPrevious,
      _ref$isFirstStep = _ref.isFirstStep,
      isFirstStep = _ref$isFirstStep === void 0 ? true : _ref$isFirstStep,
      _ref$isLastStep = _ref.isLastStep,
      isLastStep = _ref$isLastStep === void 0 ? false : _ref$isLastStep;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setErrors = _useFormikContext.setErrors;

  return React__default.createElement(Box, {
    sx: {
      mt: 4,
      borderTop: '1px solid',
      borderColor: 'neutral.l3',
      pt: 3,
      display: 'flex',
      flexFlow: ['column nowrap', 'row nowrap'],
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  }, React__default.createElement(Button, {
    type: "submit",
    sx: {
      order: [0, 1],
      mb: [2, 0],
      ml: [0, 2],
      width: ['100%', 180]
    }
  }, isFirstStep ? 'Start now' : isLastStep ? submitMessage : 'Continue'), !isFirstStep && React__default.createElement(Button, {
    variant: "secondary",
    sx: {
      width: ['100%', 180]
    },
    onClick: function onClick() {
      setErrors({});
      onPrevious(values);
    }
  }, "Back"));
};

var Sidebar = function Sidebar(_ref) {
  var children = _ref.children;
  return React__default.createElement(Box, {
    as: "header",
    sx: {
      display: 'flex',
      px: 4,
      py: 4,
      '@media screen and (max-width: 80em)': {
        display: 'none'
      },
      width: '100%',
      maxWidth: 480,
      bg: 'neutral.l3',
      minHeight: '100vh'
    }
  }, children);
};

var Progress = function Progress(_ref) {
  var _colors$gradients;

  var _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0 : _ref$progress,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, ["progress", "sx"]);

  var _useThemeUI = useThemeUI(),
      colors = _useThemeUI.theme.colors;

  return React__default.createElement(Box, Object.assign({
    sx: _extends(_extends({}, sx), {}, {
      width: '100%',
      height: 8,
      bg: 'neutral.l3',
      borderRadius: 'rounded'
    })
  }, props), React__default.createElement(Box, {
    sx: {
      height: 8,
      width: progress + "%",
      // @ts-ignore
      background: (colors === null || colors === void 0 ? void 0 : (_colors$gradients = colors.gradients) === null || _colors$gradients === void 0 ? void 0 : _colors$gradients.primary) || (colors === null || colors === void 0 ? void 0 : colors.primary),
      borderRadius: 'rounded'
    },
    role: "progressbar",
    "aria-valuenow": progress,
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }));
};

var ProgressSteps = function ProgressSteps(_ref) {
  var steps = _ref.steps,
      _ref$currentStep = _ref.currentStep,
      currentStep = _ref$currentStep === void 0 ? 0 : _ref$currentStep,
      sx = _ref.sx,
      props = _objectWithoutPropertiesLoose(_ref, ["steps", "currentStep", "sx"]);

  var currentStepIndex = currentStep;
  var progress = currentStepIndex / steps.length * 100;
  var stepInfo = "(Step " + (currentStepIndex + 1) + " of " + steps.length + ")";
  return React__default.createElement(Box, Object.assign({
    sx: sx
  }, props), React__default.createElement(Progress, {
    progress: progress
  }), React__default.createElement(Box, {
    sx: {
      display: ['block', 'none'],
      mt: 1,
      color: 'neutral.d1',
      fontWeight: 500
    },
    variant: "text.small"
  }, stepInfo), React__default.createElement(Grid, {
    columns: steps.length,
    sx: {
      mt: 1,
      fontWeight: 500,
      display: ['none', 'grid']
    }
  }, steps.map(function (_ref2, index) {
    var name = _ref2.name;
    return React__default.createElement(Box, {
      key: name.replace(/ /g, '-').toLowerCase(),
      variant: "text.small",
      sx: {
        color: currentStepIndex === index ? 'neutral.d1' : 'neutral.l1'
      }
    }, name, React__default.createElement(VisuallyHidden, null, " ", stepInfo));
  })));
};

var InternalWizard = function InternalWizard(_ref) {
  var children = _ref.children,
      initialValues = _ref.initialValues,
      onSubmit = _ref.onSubmit,
      submitMessage = _ref.submitMessage,
      sidebar = _ref.sidebar,
      internalSteps = _ref.steps;

  var _useState = useState(0),
      stepNumber = _useState[0],
      setStepNumber = _useState[1];

  var steps = React__default.Children.toArray(children);

  var _useState2 = useState(initialValues),
      snapshot = _useState2[0],
      setSnapshot = _useState2[1];

  var step = steps[stepNumber];
  var totalSteps = steps.length;
  var isLastStep = stepNumber === totalSteps - 1; // this is crap, but it gets the current progress from the key values in prop

  var key = step.key.toString();
  var progressStep = Number.parseInt(key.slice(key.indexOf('$') + 1), 10);

  var next = function next(values) {
    setSnapshot(values);
    setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
  };

  var previous = function previous(values) {
    setSnapshot(values);
    setStepNumber(Math.max(stepNumber - 1, 0));
  };

  var handleSubmit = function handleSubmit(values, bag) {
    try {
      var _temp3 = function _temp3() {
        if (response === false) return;

        if (isLastStep) {
          onSubmit(values, bag);
        } else {
          bag.setTouched({});
          next(values);
        }
      };

      var response = true;

      var _temp4 = function () {
        if (step.props.onSubmit) {
          return Promise.resolve(step.props.onSubmit(values, bag)).then(function (_step$props$onSubmit) {
            response = _step$props$onSubmit;
          });
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return jsx(Box, {
    as: "section",
    sx: {
      display: 'flex',
      '@media screen and (max-width: 80em)': {
        display: 'block'
      },
      maxWidth: 1400,
      mx: 'auto'
    }
  }, stepNumber === 0 ? jsx(StartHero, null) : jsx(Sidebar, null, sidebar), jsx(Box, {
    sx: {
      width: '100%',
      px: 4
    }
  }, stepNumber !== 0 && jsx(Box, {
    sx: {
      pb: 3,
      mb: 3,
      borderBottom: '1px solid',
      borderColor: 'neutral.l3'
    }
  }, jsx(ProgressSteps, {
    steps: internalSteps,
    currentStep: progressStep
  })), jsx(Form, {
    initialValues: snapshot,
    onSubmit: handleSubmit,
    validationSchema: step.props.validationSchema
  }, step, jsx(ButtonControls, {
    submitMessage: submitMessage,
    onPrevious: previous,
    isLastStep: isLastStep,
    isFirstStep: stepNumber === 0
  }))));
};
var WizardStep = function WizardStep(_ref2) {
  var children = _ref2.children;
  return children;
};
var Wizard = function Wizard(_ref3) {
  var steps = _ref3.steps,
      rest = _objectWithoutPropertiesLoose(_ref3, ["steps"]);

  return jsx(InternalWizard, Object.assign({
    steps: steps
  }, rest), steps.map(function (_ref4, mainStepIndex) {
    var component = _ref4.component,
        props = _objectWithoutPropertiesLoose(_ref4, ["component"]);

    if (props.substeps) {
      var stepLength = props.substeps.length;
      return props.substeps.map(function (_ref5, index) {
        var subComponent = _ref5.component,
            subProps = _objectWithoutPropertiesLoose(_ref5, ["component"]);

        return jsx(WizardStep, Object.assign({
          key: mainStepIndex + "." + index,
          isSubStep: true,
          isLastStep: stepLength === index + 1,
          isFirstStep: index === 0
        }, subProps), subComponent);
      });
    }

    return jsx(WizardStep, Object.assign({}, props, {
      key: mainStepIndex
    }), component);
  }));
};

var Divider = function Divider(props) {
  return React__default.createElement(Box, Object.assign({
    as: "hr",
    sx: {
      border: '1px solid',
      borderColor: 'neutral.l3'
    }
  }, props));
};

var LUMOS_ONLY_SELECT = function LUMOS_ONLY_SELECT(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      name = _ref.name,
      label = _ref.label,
      description = _ref.description,
      items = _ref.items,
      selectedValueItem = _ref.selectedValueItem,
      onChange = _ref.onChange,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx,
      props = _objectWithoutPropertiesLoose(_ref, ["width", "name", "label", "description", "items", "selectedValueItem", "onChange", "sx"]);

  var _React$useContext = React__default.useContext(INTERNAL_ONLY_FORM_INFO),
      prefix = _React$useContext.prefix;

  var inputId = prefix + "-" + name;
  var descriptionId = inputId + "-description";
  var options = {
    'aria-describedby': descriptionId
  };

  var _useSelect = useSelect({
    items: items,
    itemToString: function itemToString(item) {
      return item.name;
    },
    onSelectedItemChange: function onSelectedItemChange(item) {
      onChange(item.selectedItem);
    },
    labelId: inputId,
    selectedItem: selectedValueItem
  }),
      isOpen = _useSelect.isOpen,
      selectedItem = _useSelect.selectedItem,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getLabelProps = _useSelect.getLabelProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps;

  return jsx(Box, Object.assign({
    sx: sx
  }, props), jsx("label", Object.assign({}, getLabelProps()), jsx(VisuallyHidden, null, label)), jsx(Box, Object.assign({
    as: "button",
    type: "button",
    variant: "inputContainer.select",
    sx: {
      width: width
    }
  }, getToggleButtonProps()), jsx("div", null, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) || 'Select'), jsx(Icon, {
    variant: "color-triangle",
    sx: {
      transform: isOpen ? 'rotate(180deg)' : undefined
    }
  })), jsx("div", {
    sx: {
      position: 'relative'
    }
  }, jsx(Box, Object.assign({
    as: "ul",
    variant: "inputContainer.dropzone",
    role: "listbox"
  }, getMenuProps(options), {
    sx: !isOpen ? {
      border: 'none',
      m: 0,
      boxShadow: 0,
      p: 0
    } : {}
  }), isOpen && items.map(function (item, index) {
    return jsx(Box, Object.assign({
      className: [highlightedIndex === index ? 'active' : '', (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value ? 'selected' : ''].join(' '),
      as: "li",
      role: "option",
      variant: "inputContainer.listItem",
      key: item.value.replace(/ /g, '')
    }, getItemProps({
      item: item,
      index: index
    })), item.name);
  }))), jsx(VisuallyHidden, {
    id: descriptionId
  }, description));
};

var TabsMobile = function TabsMobile(_ref) {
  var tabs = _ref.tabs,
      currentIndex = _ref.currentIndex,
      _onChange = _ref.onChange,
      children = _ref.children;
  var selectedTab = tabs[currentIndex];
  return React__default.createElement(Box, null, React__default.createElement(Box, {
    sx: {
      display: 'flex'
    }
  }, React__default.createElement(LUMOS_ONLY_SELECT, {
    name: "test",
    selectedValueItem: {
      name: selectedTab.label,
      value: selectedTab.id
    },
    label: "something",
    items: tabs.map(function (x) {
      return {
        name: x.label,
        value: x.id
      };
    }),
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      return _onChange(value);
    },
    sx: {
      width: '100%',
      button: {
        height: 48,
        border: 'none',
        borderBottom: '2px solid',
        borderColor: 'secondary.base',
        borderRadius: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 24px',
        fontWeight: 600
      }
    }
  }), children), React__default.createElement("div", null, selectedTab.content));
};

/** @jsx jsx */

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      selectedKey = _ref.selectedKey,
      onChange = _ref.onChange,
      children = _ref.children,
      _ref$allowMobile = _ref.allowMobile,
      allowMobile = _ref$allowMobile === void 0 ? false : _ref$allowMobile;
  var i = tabs.findIndex(function (x) {
    return x.id === selectedKey;
  });

  var _React$useState = React__default.useState(i !== -1 ? i : 0),
      currentIndex = _React$useState[0],
      changeIndex = _React$useState[1];

  var handleChange = function handleChange(selectedIndex) {
    changeIndex(selectedIndex);

    if (onChange) {
      var _tabs$selectedIndex;

      onChange((_tabs$selectedIndex = tabs[selectedIndex]) === null || _tabs$selectedIndex === void 0 ? void 0 : _tabs$selectedIndex.id);
    }
  };

  var handleMobileChange = function handleMobileChange(value) {
    var selectedIndex = tabs.findIndex(function (_ref2) {
      var id = _ref2.id;
      return id === value;
    });
    if (selectedIndex !== -1) changeIndex(selectedIndex);
    if (onChange) onChange(value);
  };

  React__default.useEffect(function () {
    var selectedIndex = tabs.findIndex(function (_ref3) {
      var id = _ref3.id;
      return id === selectedKey;
    });
    if (selectedIndex !== -1) changeIndex(selectedIndex);
  }, [selectedKey]);
  return jsx(React__default.Fragment, null, jsx(Box, {
    sx: {
      display: allowMobile ? ['none', 'none', 'block'] : 'block'
    }
  }, jsx(Tabs$1, {
    index: currentIndex,
    onChange: handleChange
  }, function (_ref4) {
    var selectedIndex = _ref4.selectedIndex;

    var getPrimaryTabStyle = function getPrimaryTabStyle(index) {
      var isSelected = index === selectedIndex;
      return {
        color: isSelected ? 'text.positive' : 'neutral.base',
        py: 3,
        fontSize: 2,
        mr: 3,
        fontWeight: 600,
        border: 'none',
        borderBottom: '2px solid',
        borderColor: isSelected ? 'secondary.base' : 'transparent',
        mb: '-1px',
        bg: 'transparent',
        ':hover': {
          borderColor: isSelected ? 'secondary.base' : 'secondary.l2'
        }
      };
    };

    var getSecondaryTabStyle = function getSecondaryTabStyle(index) {
      var isSelected = index === selectedIndex;
      return {
        color: isSelected ? 'text.positive' : 'neutral.base',
        py: 2,
        fontSize: 2,
        mr: 3,
        border: 'none',
        borderBottom: '2px solid',
        borderColor: isSelected ? 'neutral.d2' : 'transparent',
        mb: '-1px',
        bg: 'transparent',
        ':hover': {
          borderColor: isSelected ? 'neutral.d2' : 'neutral.l2'
        }
      };
    };

    return [jsx(TabList, {
      sx: {
        borderBottom: '1px solid',
        borderColor: 'neutral.l3',
        'button:last-of-type': {
          mr: 0
        }
      }
    }, tabs.map(function (_ref5, index) {
      var label = _ref5.label,
          id = _ref5.id;
      return jsx(Tab, {
        key: id,
        sx: variant === 'primary' ? getPrimaryTabStyle(index) : getSecondaryTabStyle(index)
      }, label);
    })), jsx(TabPanels, null, tabs.map(function (_ref6) {
      var content = _ref6.content,
          id = _ref6.id;
      return jsx(TabPanel, {
        key: id
      }, content);
    }))];
  })), jsx(Box, {
    sx: {
      display: allowMobile ? ['block', 'block', 'none'] : 'none'
    }
  }, jsx(TabsMobile, {
    tabs: tabs,
    currentIndex: currentIndex,
    variant: variant,
    onChange: handleMobileChange
  }, children)));
};

var LoanSearch = function LoanSearch(_ref) {
  var onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      results = _ref.results,
      renderNode = _ref.renderNode,
      label = _ref.label,
      isLoading = _ref.isLoading,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'right' : _ref$position;

  var _useCombobox = useCombobox({
    onSelectedItemChange: function onSelectedItemChange(_ref2) {
      var selectedItem = _ref2.selectedItem;
      return onSelect(selectedItem);
    },
    itemToString: function itemToString(item) {
      return (item === null || item === void 0 ? void 0 : item.id) || '';
    },
    onInputValueChange: function onInputValueChange(_ref3) {
      var inputValue = _ref3.inputValue;
      return onChange(inputValue);
    },
    items: results
  }),
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getMenuProps = _useCombobox.getMenuProps,
      getItemProps = _useCombobox.getItemProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      isOpen = _useCombobox.isOpen;

  var showResults = Boolean(!isLoading && results && results.length);
  var showNoResults = Boolean(!isLoading && results && !results.length);
  var style = position === 'left' ? {
    left: 0
  } : {
    right: 0
  };
  return React__default.createElement("div", null, React__default.createElement("div", Object.assign({}, getComboboxProps()), React__default.createElement(Box, {
    variant: "inputContainer.box",
    sx: {
      m: 0,
      p: 0
    }
  }, React__default.createElement(VisuallyHidden, null, React__default.createElement("label", {
    id: "loanSearch"
  }, label)), React__default.createElement(Grid, {
    columns: "22px 1fr",
    gap: 0
  }, React__default.createElement(Box, {
    variant: "inputContainer.prefix",
    sx: {
      px: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 36
    }
  }, React__default.createElement(Icon, {
    variant: "search",
    size: "sm",
    color: "primary.base",
    sx: {
      'i::before': {
        mx: 0
      },
      ml: 1
    }
  })), React__default.createElement(Box, Object.assign({
    variant: "inputContainer.base",
    htmlFor: "loanSearch",
    as: "input"
  }, getInputProps(), {
    placeholder: label,
    sx: {
      borderLeft: 0,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      minHeight: 36
    }
  }))))), React__default.createElement(Box, Object.assign({
    as: "ul"
  }, getMenuProps(), {
    sx: {
      position: 'relative'
    }
  }), isOpen && React__default.createElement(Card, {
    variant: "float",
    sx: _extends({
      position: 'absolute',
      width: ['100%', 450],
      zIndex: 99999,
      p: 0,
      maxHeight: 300,
      overflowY: 'scroll',
      li: {
        '&:first-of-type': {
          borderTopLeftRadius: 'rounded',
          borderTopRightRadius: 'rounded'
        },
        '&:last-of-type': {
          borderBottomLeftRadius: 'rounded',
          borderBottomRightRadius: 'rounded'
        }
      }
    }, style)
  }, isLoading && React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      p: 3
    }
  }, React__default.createElement(Spinner, {
    color: "secondary.base",
    sx: {
      mr: 2
    },
    size: 30
  }), "Searching..."), showNoResults && React__default.createElement(Box, {
    sx: {
      m: 3,
      display: 'flex',
      alignItems: 'center',
      p: 3,
      bg: 'primary.l4',
      border: '1px dashed',
      borderColor: 'primary.l2'
    }
  }, "No results found"), showResults && results.map(function (item, index) {
    return React__default.createElement(Box, Object.assign({
      as: "li",
      sx: {
        p: 2,
        listStyleType: 'none',
        cursor: 'pointer',
        bg: highlightedIndex === index ? 'primary.l4' : 'white'
      }
    }, getItemProps({
      item: item,
      index: index
    })), renderNode(item));
  }))));
};

export { AddressInput, AlertBanner, AlertInline, Badge, Button, ButtonBack, ButtonLink, Card, CheckboxWithOther, ChoiceInput, Collapsible, CompletionList, ConfirmInput, DataList, DateInput, RadioInput$1 as DecisionInput, Divider, Drawer, DrawerControls, Form, Heading, Icon, LUMOS_ONLY_SELECT, Logo, Menu, Modal, ModalControls, MultiSelect, Navbar$2 as NavBar, NotifyProvider, NumberInput, PercentageInput, Persist, Progress as ProgressBar, LoanSearch as SearchInput, SecretInput, SectionGroup, Signature, SingleSelect, SingleSelect$1 as SingleSelectOther, Tabs, Tag, TextArea, TextInput, ToggleSwitch, Tooltip, VisuallyHidden, Wizard, useMobileToggle, useNotify };
//# sourceMappingURL=lumos__core.esm.js.map
